<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col ">
              <h3 class="page-title m-0">
			                <span class="page-title-icon bg-gradient-primary text-white mr-2">
			                  <i class="feather-smartphone"></i>
			                </span> TOMs </h3>
            </div>
            <div class="col text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">TOMs</li>
              </ul>
            </div>
          </div>
      <div id="surveyContainer" v-show="!surveyConfirmed">
        <survey :survey="survey">
        </survey>
      </div>
      <div v-show="surveyConfirmed">
        <div class="card">
          <div class="card-header clearfix text-left" style="margin: 20px auto">
            <h4>Zusammenfassung</h4>
          </div>
          <div class="card-body text-left">
            <p><strong>Mandant:</strong> {{ account.name }} </p>
            <p><strong>Betreff:</strong> TOMs Audit</p>
            <p><strong>TOMs:</strong> <a :href="baseURL + '/survey/v1/download/?filename=' + surveyResponse.report_url_toms" target="_blank" class="FileLink">{{ surveyResponse.customer_name }}_Toms_Bericht.docx</a></p>
            <p><strong>Auditbericht:</strong> <a :href="baseURL + '/survey/v1/download/?filename=' + surveyResponse.report_url_audit" target="_blank" class="FileLink">{{ surveyResponse.customer_name }}_Auditbericht.docx</a></p>
            <p><strong>Todo-Liste:</strong> <a :href="baseURL + '/survey/v1/download/?filename=' + surveyResponse.report_url_todos" target="_blank" class="FileLink">{{ surveyResponse.customer_name }}_To-do_list.docx</a></p>
            <p><strong>Datum:</strong> {{ surveyResponse.createdon }}</p>
          </div>
        </div>
      </div>
      <modal width="80%" v-show="dialogVisible" @close="dialogVisible=false">
        <template v-slot:header><h4>Bitte die Prüfergebnisse bestätigen</h4></template>
        <template v-slot:body>
          <h4>Prüfbericht: DDK - TOMS Report - {{ reportDate }}</h4>
          <h4>{{account.name}}</h4>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Zutrittskontrolle</h4>
            </div>
            <h5>Vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.zutrittskontrolle.yes.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.zutrittskontrolle.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.zutrittskontrolle.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.zutrittskontrolle.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.zutrittskontrolle.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.zutrittskontrolle.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Zugangskontrolle</h4>
            </div>
            <h5>Vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugangskontrolle.yes.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Zugangskontrolle.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugangskontrolle.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Zugangskontrolle.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugangskontrolle.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Zugangskontrolle.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Zugriffskontrolle</h4>
            </div>
            <h5>Vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugriffskontrolle.yes.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Zugriffskontrolle.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugriffskontrolle.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Zugriffskontrolle.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugriffskontrolle.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Zugriffskontrolle.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Weitergabekontrolle</h4>
            </div>
            <h5>Vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Weitergabekontrolle.yes.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Weitergabekontrolle.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle green"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Weitergabekontrolle.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Weitergabekontrolle.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Weitergabekontrolle.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Weitergabekontrolle.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Pseudonymisierung</h4>
            </div>
            <h5>Vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Pseudonymisierung.yes.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Pseudonymisierung.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Pseudonymisierung.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Pseudonymisierung.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Pseudonymisierung.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Pseudonymisierung.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Trennungskontrolle</h4>
            </div>
            <h5>Vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Trennungskontrolle.yes.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Trennungskontrolle.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Trennungskontrolle.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Trennungskontrolle.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Trennungskontrolle.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Trennungskontrolle.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Eingabekontrolle</h4>
            </div>
            <h5>Vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Eingabekontrolle.yes.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Eingabekontrolle.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Eingabekontrolle.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Eingabekontrolle.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Eingabekontrolle.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Eingabekontrolle.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Verfügbarkeitskontrolle</h4>
            </div>
            <h5>Vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Verfuegbarkeitskontrolle.yes.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Verfuegbarkeitskontrolle.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Verfuegbarkeitskontrolle.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Verfuegbarkeitskontrolle.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Verfuegbarkeitskontrolle.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Verfuegbarkeitskontrolle.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Auftragskontrolle</h4>
            </div>
            <h5>Vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Auftragskontrolle.yes.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Auftragskontrolle.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Auftragskontrolle.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Auftragskontrolle.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Auftragskontrolle.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Auftragskontrolle.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <div class="row" style="margin: 5px">
              <h4 class="dialogtitle">Organisatorische Sicherheitskriterien</h4>
            </div>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Organisatorische.yes.length>0">
              <h5>Vorhandene Maßnahmen</h5>
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Organisatorische.yes" :key="index">
                <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Teilweise vorhandene Maßnahmen</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Organisatorische.partial.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Organisatorische.partial" :key="index">
                <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
            <h5>Ausstehende Maßnahme (To-do)</h5>
            <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Organisatorische.no.length>0">
              <tr>
                <td >Status</td>
                <td>Maßnahme</td>
                <td>Bemerkung</td>
              </tr>
              <tr v-for="(item, index) in organizedResult.Organisatorische.no" :key="index">
                <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                </th>
                <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                </th>
              </tr>
            </table>
          </div>
          <div><br></div>
          <div>
            <van-field
              type="textarea"
              :rows="2"
              placeholder="Kommentar für den Bericht"
              v-model="surveyComment">
            </van-field>
            <!--<ckeditor :editor="editor" v-model="surveyComment" ></ckeditor>-->
          </div>
        </template>
        <template v-slot:footer>
          <button class="btn btn-outline-danger" @click="closeDiaglog">Abbrechen</button>
          <button class="btn btn-primary" type="primary" @click="confirmResult">Bestätigen</button>
        </template>
      </modal>
      <Modal
        title="Fragen Suchen"
        v-show="searchPageVisible"
        width="80%"
        @close="searchPageVisible=false">
        <template v-slot:body>
          <v-autocomplete
            :items="items"
            :get-label="getLabel"
            @update-items="update"
            :component-item="template"
            @item-clicked="itemClicked"
            :input-attrs="{name: 'input-test', id: 'v-my-autocomplete', autofocus:true, placeholder: 'Begriffe eingeben'}"
            :auto-select-one-item="false">
          </v-autocomplete>
        </template>
      </Modal>
      <div class="btn-group survey-menu">
        <button class="btn btn-outline-secondary" @click="exportSurveyToExcel">Prüfbogen exportieren</button>
        <button type="button" class="btn btn-outline-primary" @click.prevent="searchPageVisible=!searchPageVisible">Suche</button>
        <button class="btn btn-outline-dark dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="feather-search"></i>
        </button>
        <div class="dropdown-menu" style="will-change: transform;">
          <a href="#" @click.prevent="gotoPage(index)" class="dropdown-item" :href="index" v-for="(page, index) in survey_pages" :key="index">{{ page.title }}</a>
        </div>
      </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as SurveyVue from 'survey-vue';
  import "survey-vue/defaultV2.css";
  import { service, baseURL } from '@/utils/request.js'
  import Autocomplete from 'v-autocomplete'
  import QuestionList from './QuestionList.vue'
  import Modal from "@/components/component/Modal.vue";
  import { Field, Dialog } from 'vant';
  import * as widgets from "surveyjs-widgets";
  // import 'survey-core/defaultV2.min.css'

  import { init as customWidget } from "@/components/survey/customwidget";
  import {mapGetters, mapState} from "vuex";
  import {makeTOMCoverSheet, surveyToExcel} from "@/utils/exportToExcel";

  SurveyVue.StylesManager.applyTheme("defaultV2");
  const Survey = SurveyVue.Survey;

  customWidget(SurveyVue);

const failed = 'ff0000'
const passed = '00ff00'
export default {
  name: 'SurveyContent',
  components: {
    Modal,
    Survey,
    'v-autocomplete': Autocomplete,
    'van-field': Field,
    'van-dialog': Dialog
    // ckeditor : CKEditor.component
  },
  props: {
    surveyResult: {
      default: () => ({}),
      type: Object
    }
  },
  data: function() {
    const model = new SurveyVue.Model(this.surveyJSON)
    return {
      survey: model,
      surveyJSON: '',
      survey_pages: [],
      search_keywords: '',
      searchPageVisible: false,
      loading: true,
      saveKey: `tom_${this.$store.getters.id}_${this.$store.getters.accountid}`,
      dialogVisible: false,
      completeOption: false,
      surveyConfirmed: false,
      selected_accounts: [],
      accounts: [],
      accounts_loading: false,
      reportDate: Date.now(),
      mandantName: '',
      // editor: ClassicEditor,
      surveyComment: '',
      item: {},
      items: [],
      template: QuestionList,
      surveyResponse: {},
      resultBody: {},
      resultRelation: {
        'question1': 'zutrittskontrolle',
        'question2': 'zutrittskontrolle',
        'question4': 'zutrittskontrolle',
        'question3': 'zutrittskontrolle',
        'question143': 'zutrittskontrolle',
        'question5': 'zutrittskontrolle',
        'question6': 'zutrittskontrolle',
        'question7-1': 'zutrittskontrolle',
        'question7': 'zutrittskontrolle',
        'question9-1': 'zutrittskontrolle',
        'question8': 'zutrittskontrolle',
        'question9': 'zutrittskontrolle',
        'question10': 'zutrittskontrolle',
        'question11': 'zutrittskontrolle',
        'question12': 'zutrittskontrolle',
        'question13': 'zutrittskontrolle',
        'question14': 'zutrittskontrolle',
        'question14-1': 'zutrittskontrolle',
        'question15': 'zutrittskontrolle',
        'question16': 'zutrittskontrolle',
        'question17': 'zutrittskontrolle',
        'question18': 'zutrittskontrolle',
        'question19': 'zutrittskontrolle',
        'question21': 'zutrittskontrolle',
        'question20': 'zutrittskontrolle',
        'question53': 'zutrittskontrolle',
        'question22': 'Zugangskontrolle',
        'question23': 'Zugangskontrolle',
        'question55': 'Zugangskontrolle',
        'question24': 'Zugangskontrolle',
        'question25': 'Zugangskontrolle',
        'question26': 'Zugangskontrolle',
        'question27': 'Zugangskontrolle',
        'question69': 'Zugangskontrolle',
        'question28': 'Zugangskontrolle',
        'question66': 'Zugangskontrolle',
        'question64': 'Zugangskontrolle',
        'question67': 'Zugangskontrolle',
        'question68': 'Zugangskontrolle',
        'question65': 'Zugangskontrolle',
        'question29': 'Zugriffskontrolle',
        'question30': 'Zugriffskontrolle',
        'question31': 'Zugriffskontrolle',
        'question32': 'Zugriffskontrolle',
        'question70': 'Zugriffskontrolle',
        'question71': 'Zugriffskontrolle',
        'question72': 'Zugriffskontrolle',
        'question73': 'Zugriffskontrolle',
        'question74': 'Zugriffskontrolle',
        'question75': 'Zugriffskontrolle',
        'question33': 'Weitergabekontrolle',
        'question76': 'Weitergabekontrolle',
        'question77': 'Weitergabekontrolle',
        'question78': 'Weitergabekontrolle',
        'question79': 'Weitergabekontrolle',
        'question36': 'Weitergabekontrolle',
        'question81': 'Weitergabekontrolle',
        'question82': 'Weitergabekontrolle',
        'question34': 'Weitergabekontrolle',
        'question80': 'Weitergabekontrolle',
        'question83': 'Weitergabekontrolle',
        'question39': 'Weitergabekontrolle',
        'question35': 'Weitergabekontrolle',
        'question37': 'Weitergabekontrolle',
        'question40': 'Pseudonymisierung',
        'question41': 'Trennungskontrolle',
        'question42': 'Trennungskontrolle',
        'question43': 'Trennungskontrolle',
        'question38': 'Trennungskontrolle',
        'question84': 'Trennungskontrolle',
        'question44': 'Trennungskontrolle',
        'question85': 'Trennungskontrolle',
        'question86': 'Trennungskontrolle',
        'question45': 'Eingabekontrolle',
        'question46': 'Eingabekontrolle',
        'question47': 'Eingabekontrolle',
        'question87': 'Eingabekontrolle',
        'question88': 'Eingabekontrolle',
        'question89': 'Eingabekontrolle',
        'question90': 'Eingabekontrolle',
        'question91': 'Eingabekontrolle',
        'question48': 'Verfuegbarkeitskontrolle',
        'question92': 'Verfuegbarkeitskontrolle',
        'question93': 'Verfuegbarkeitskontrolle',
        'question94': 'Verfuegbarkeitskontrolle',
        'question95': 'Verfuegbarkeitskontrolle',
        'question96': 'Verfuegbarkeitskontrolle',
        'question97': 'Verfuegbarkeitskontrolle',
        'question98': 'Verfuegbarkeitskontrolle',
        'question99': 'Verfuegbarkeitskontrolle',
        'question100': 'Verfuegbarkeitskontrolle',
        'question101': 'Verfuegbarkeitskontrolle',
        'question105': 'Verfuegbarkeitskontrolle',
        'question106': 'Verfuegbarkeitskontrolle',
        'question107': 'Verfuegbarkeitskontrolle',
        'question102': 'Verfuegbarkeitskontrolle',
        'question103': 'Verfuegbarkeitskontrolle',
        'question104': 'Verfuegbarkeitskontrolle',
        'question108': 'Verfuegbarkeitskontrolle',
        'question109': 'Verfuegbarkeitskontrolle',
        'question110': 'Verfuegbarkeitskontrolle',
        'question111': 'Verfuegbarkeitskontrolle',
        'question112': 'Verfuegbarkeitskontrolle',
        'question113': 'Verfuegbarkeitskontrolle',
        'question114': 'Verfuegbarkeitskontrolle',
        'question115': 'Verfuegbarkeitskontrolle',
        'question116': 'Verfuegbarkeitskontrolle',
        'question117': 'Verfuegbarkeitskontrolle',
        'question118': 'Verfuegbarkeitskontrolle',
        'question119': 'Verfuegbarkeitskontrolle',
        'question120': 'Verfuegbarkeitskontrolle',
        'question121': 'Verfuegbarkeitskontrolle',
        'question122': 'Verfuegbarkeitskontrolle',
        'question123': 'Verfuegbarkeitskontrolle',
        'question49': 'Verfuegbarkeitskontrolle',
        'question50': 'Verfuegbarkeitskontrolle',
        'question52': 'Verfuegbarkeitskontrolle',
        'question54': 'Verfuegbarkeitskontrolle',
        'question56': 'Verfuegbarkeitskontrolle',
        'question124': 'Verfuegbarkeitskontrolle',
        'question125': 'Verfuegbarkeitskontrolle',
        'question126': 'Verfuegbarkeitskontrolle',
        'question127': 'Verfuegbarkeitskontrolle',
        'question128': 'Verfuegbarkeitskontrolle',
        'question129': 'Verfuegbarkeitskontrolle',
        'question130': 'Verfuegbarkeitskontrolle',
        'question131': 'Verfuegbarkeitskontrolle',
        'question132': 'Verfuegbarkeitskontrolle',
        'question133': 'Verfuegbarkeitskontrolle',
        'question134': 'Verfuegbarkeitskontrolle',
        'question135': 'Verfuegbarkeitskontrolle',
        'question136': 'Verfuegbarkeitskontrolle',
        'question137': 'Verfuegbarkeitskontrolle',
        'question138': 'Verfuegbarkeitskontrolle',
        'question139': 'Verfuegbarkeitskontrolle',
        'question57': 'Auftragskontrolle',
        'question58': 'Auftragskontrolle',
        'question60': 'Organisatorische',
        'question61': 'Organisatorische',
        'question62': 'Organisatorische',
        'question59': 'Organisatorische',
        'question140': 'Organisatorische',
        'question63': 'Organisatorische',
        'question141': 'Organisatorische',
        'question142': 'Organisatorische'
      },
      organizedResult: {
        'zutrittskontrolle': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        },
        'Zugangskontrolle': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        },
        'Zugriffskontrolle': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        },
        'Weitergabekontrolle': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        },
        'Pseudonymisierung': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        },
        'Trennungskontrolle': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        },
        'Eingabekontrolle': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        },
        'Verfuegbarkeitskontrolle': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        },
        'Auftragskontrolle': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        },
        'Organisatorische': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'yes': [],
          'no': [],
          'partial': []
        }
      },
      auditResult: {},
      resultDesc: {
        'question1': {
          'question': 'Liegt eine Beschreibung/Dokumentation der gesamten am Standort eingesetzten Zutrittskontrollmaßnahmen vor?',
          'yes': 'Es liegt eine Beschreibung/Dokumentation der gesamten am Standort eingesetzten Zutrittskontrollmaßnahmen vor.',
          'no': 'Es liegt keine Beschreibung/Dokumentation der gesamten am Standort eingesetzten Zutrittskontrollmaßnahmen vor.',
          'partial': ' Liegt eine Beschreibung/Dokumentation der gesamten am Standort eingsetzten Zutrittskontrollmaßnahmen vor?'
        },
        'question2': {
          'question': 'Gibt es am Standort maschinelle Zutrittskontrollsysteme zur Überwachung des Betretens und evtl. auch Verlassens eines Gebäudes/eines Gebäudeteils?',
          'yes': 'Am Standort gibt es maschinelle Zutrittskontrollsysteme zur Überwachung des Betretens und Verlassens des Gebäudes.',
          'no': 'Gibt es am Standort maschinelle Zutrittskontrollsysteme zur Überwachung des Betretens und evtl. auch Verlassens eines Gebäudes/eines Gebäudeteils?',
          'partial': 'Gibt es am Standort maschinelle Zutrittskontrollsysteme zur Überwachung des Betretens und evtl. auch Verlassens eines Gebäudes/eines Gebäudeteils?'
        },
        'question4': {
          'question': 'Werden eventuell biometrische Kontrollsysteme (bspw. Handflächen, Iris-Scanner, Fingerabdruck-Leser) eingesetzt?',
          'yes': 'Es werden biometrische Kontrollsysteme eingesetzt.',
          'no': 'Werden eventuell biometrische Kontrollsysteme (bspw. Handflächen, Iris-Scanner, Fingerabdruck-Leser) eingesetzt?',
          'partial': 'Werden eventuell biometrische Kontrollsysteme (bspw. Handflächen, Iris-Scanner, Fingerabdruck-Leser) eingesetzt?'
        },
        'question3': {
          'question': 'Ist die Verwaltung und Wartung der maschinellen Zutrittskontrollsysteme geregelt und dokumentiert?',
          'yes': 'Die Verwaltung und Wartung der maschinellen Zutrittskontrollsysteme ist geregelt und dokumentiert.',
          'no': 'Ist die Verwaltung und Wartung der maschinellen Zutrittskontrollsysteme geregelt und dokumentiert?',
          'partial': 'Ist die Verwaltung und Wartung der maschinellen Zutrittskontrollsysteme geregelt und dokumentiert?'
        },
        'question143': {
          'question': 'Werden in den Zutrittskontrollanlagen personenbezogene Daten gespeichert, so dass nachvollziehbar ist, wer wann einen bestimmten räumlichen Bereich betreten und ggf. auch wieder verlassen hat?',
          'yes': 'In den Zutrittskontrollanlagen werden personenbezogene Daten gespeichert, so dass nachvollziehbar ist, wer wann einen bestimmten räumlichen Bereich betreten und auch wieder verlassen hat.',
          'no': 'Werden in den Zutrittskontrollanlagen personenbezogene Daten gespeichert, so dass nachvollziehbar ist, wer wann einen bestimmten räumlichen Bereich betreten und ggf. auch wieder verlassen hat?',
          'partial': 'Werden in den Zutrittskontrollanlagen personenbezogene Daten gespeichert, so dass nachvollziehbar ist, wer wann einen bestimmten räumlichen Bereich betreten und ggf. auch wieder verlassen hat?'
        },
        'question5': {
          'question': 'Werden die protokollierten Daten regelmäßig oder aufgrund besonderer Anlässe wie nach (versuchten) Sicherheitsverletzungen ausgewertet?',
          'yes': 'Die protokollierten Daten werden regelmäßig oder aufgrund besonderer Anlässe ausgewertet.',
          'no': 'Werden die protokollierten Daten regelmäßig oder aufgrund besonderer Anlässe wie nach (versuchten) Sicherheitsverletzungen ausgewertet?',
          'partial': 'Werden die protokollierten Daten regelmäßig oder aufgrund besonderer Anlässe wie nach (versuchten) Sicherheitsverletzungen ausgewertet?'
        },
        'question6': {
          'question': 'Um welche Bebauungsart handelt es sich?',
          'item1': 'Es handelt sich um Freistehender Gebäudekomplex',
          'item2': 'Es handelt sich um Geschlossene Bebauung',
          'item3': 'Es handelt sich um Mit Werksgelände',
          'item4': 'Es handelt sich um umzäuntes Grundstück',
          'item5': 'Es handelt sich um offen zugängliches Grundstück',
          'other': 'Es handelt sich um eine andere Bebauungsart'
        },
        'question7-1': {
          'question': 'Gibt es ein Gebäude-Sicherungskonzept, welches auf die Zutrittsmöglichkeiten eingeht?',
          'yes': 'Es gibt ein Gebäude-Sicherungskonzept, welches auf die Zutrittsmöglichkeiten eingeht.',
          'no': 'Gibt es ein Gebäude-Sicherungskonzept, welches auf die Zutrittsmöglichkeiten eingeht?',
          'partial': 'Gibt es ein Gebäude-Sicherungskonzept, welches auf die Zutrittsmöglichkeiten eingeht?'
        },
        'question7': {
          'question': 'Sind Sicherheitszonen im Gebäude-Sicherungskonzept beschrieben?',
          'yes': 'Im Gebäude-Sicherungskonzept sind Sicherheitszonen beschrieben.',
          'no': 'Sind Sicherheitszonen im Gebäude-Sicherungskonzept beschrieben?',
          'partial': 'Sind Sicherheitszonen im Gebäude-Sicherungskonzept beschrieben?'
        },
        'question9-1': {
          'question': 'Sind Sicherheitszonen unterschiedlicher Klassifizierung und Sensibilität vorgesehen?',
          'yes': 'Im Gebäude-Sicherungskonzept sind Sicherheitszonen unterschiedlicher Klassifizierung und Sensibilität vorgesehen.',
          'no': 'Sind Sicherheitszonen unterschiedlicher Klassifizierung und Sensibilität vorgesehen?',
          'partial': 'Sind Sicherheitszonen unterschiedlicher Klassifizierung und Sensibilität vorgesehen?'
        },
        'question8': {
          'question': 'Sind die Verteilerräume oder -bereiche (Gebäudetechnik) gegen unbefugten Zutritt gesichert?',
          'yes': 'Die Verteilerräume oder -bereiche der Gebäudetechnik sind gegen unbefugten Zutritt gesichert.',
          'no': 'Sind die Verteilerräume oder -bereiche (Gebäudetechnik) gegen unbefugten Zutritt gesichert?',
          'partial': 'Sind die Verteilerräume oder -bereiche (Gebäudetechnik) gegen unbefugten Zutritt gesichert?'
        },
        'question9': {
          'question': 'Ist eine durchgängige Außenhautsicherung (einbruchshemmende Maßnahmen) vorhanden?',
          'yes': 'Es ist eine durchgängige Außenhautsicherung mit einbruchshemmenden Maßnahmen vorhanden.',
          'no': 'Ist eine durchgängige Außenhautsicherung (einbruchshemmende Maßnahmen) vorhanden?',
          'partial': 'Ist eine durchgängige Außenhautsicherung (einbruchshemmende Maßnahmen) vorhanden?'
        },
        'question10': {
          'question': 'Sind Sicherungsmaßnahmen gegen Überfälle im Einsatz (bspw. Gegensprechanlagen, elektrische Türöffner, Lichtschranken, Überfallmelder, Videoüberwachung)?',
          'yes': 'Es gibt Sicherungsmaßnahmen gegen Überfälle.',
          'no': 'Sind Sicherungsmaßnahmen gegen Überfälle im Einsatz (bspw. Gegensprechanlagen, elektrische Türöffner, Lichtschranken, Überfallmelder, Videoüberwachung)?',
          'partial': 'Sind Sicherungsmaßnahmen gegen Überfälle im Einsatz (bspw. Gegensprechanlagen, elektrische Türöffner, Lichtschranken, Überfallmelder, Videoüberwachung)?'
        },
        'question11': {
          'question': 'Existieren angemessene, nicht maschinelle Zutrittskontrollen (bspw. einfache Schlösser) zu dem Gebäude?',
          'yes': 'Es existieren angemessene, nicht maschinelle Zutrittskontrollen zu dem/den Gebäude(n).',
          'no': 'Existieren angemessene, nicht maschinelle Zutrittskontrollen (bspw. einfache Schlösser) zu dem Gebäude?',
          'partial': 'Existieren angemessene, nicht maschinelle Zutrittskontrollen (bspw. einfache Schlösser) zu dem Gebäude?'
        },
        'question12': {
          'question': 'Liegt für alle Schlüssel (oder andere Identifikationsmittel) des Gebäudes (von Etagen, Fluren und Räumen) ein Schließplan vor?',
          'yes': 'Für alle Schlüssel oder andere Identifikationsmittel liegt ein Schließplan vor.',
          'no': 'Liegt für alle Schlüssel (oder andere Identifikationsmittel) des Gebäudes (von Etagen, Fluren und Räumen) ein Schließplan vor?',
          'partial': 'Liegt für alle Schlüssel (oder andere Identifikationsmittel) des Gebäudes (von Etagen, Fluren und Räumen) ein Schließplan vor?'
        },
        'question13': {
          'question': 'Ist die Herstellung, Aufbewahrung, Verwaltung und Ausgabe von Schlüsseln (oder anderer Identifikationsmittel) zentral geregelt und dokumentiert?',
          'yes': 'Die Herstellung, Aufbewahrung, Verwaltung und Ausgabe von Schlüsseln oder anderer Identifikationsmittel ist zentral geregelt und dokumentiert.',
          'no': 'Ist die Herstellung, Aufbewahrung, Verwaltung und Ausgabe von Schlüsseln (oder anderer Identifikationsmittel) zentral geregelt und dokumentiert?',
          'partial': 'Ist die Herstellung, Aufbewahrung, Verwaltung und Ausgabe von Schlüsseln (oder anderer Identifikationsmittel) zentral geregelt und dokumentiert?'
        },
        'question14': {
          'question': 'Besteht eine Pflicht zum Tragen von Dienst- oder Firmenausweisen?',
          'yes': 'Es besteht eine Pflicht zum Tragen von Dienst- oder Firmenausweisen.',
          'no': 'Besteht eine Pflicht zum Tragen von Dienst- oder Firmenausweisen?',
          'partial': 'Besteht eine Pflicht zum Tragen von Dienst- oder Firmenausweisen?'
        },
        'question14-1': {
          'question': 'Tragen alle Mitarbeiter ihre Dienst- oder Firmenausweise sichtbar?',
          'yes': 'Die Mitarbeiter tragen ihre Dienst- oder Firmenausweise sichtbar.',
          'no': 'Tragen alle Mitarbeiter ihre Dienst- oder Firmenausweise sichtbar?',
          'partial': 'Tragen alle Mitarbeiter ihre Dienst- oder Firmenausweise sichtbar?'
        },
        'question15': {
          'question': 'Besteht eine Kennzeichnungspflicht für fremde Personen durch sichtbar zu tragende Ausweise?',
          'yes': 'Es besteht eine Kennzeichnungspflicht für fremde Personen durch sichtbar zu tragende Ausweise.',
          'no': 'Besteht eine Kennzeichnungspflicht für fremde Personen durch sichtbar zu tragende Ausweise?',
          'partial': 'Besteht eine Kennzeichnungspflicht für fremde Personen durch sichtbar zu tragende Ausweise?'
        },
        'question16': {
          'question': 'Ist die Vergabe von Besucher- und Firmenausweisen revisionsfähig?',
          'yes': 'Für fremde Personen besteht eine Kennzeichnungspflicht durch sichtbar zu tragende Ausweise.',
          'no': 'Ist die Vergabe von Besucher- und Firmenausweisen revisionsfähig?',
          'partial': 'Ist die Vergabe von Besucher- und Firmenausweisen revisionsfähig?'
        },
        'question17': {
          'question': 'Werden die Unternehmensserver in einem abgeschlossenen und zutrittsgesicherten Raum betrieben?',
          'yes': 'Die Unternehmensserver werden in einem abgeschlossenen und zutrittsgesicherten Raum betrieben.',
          'no': 'Werden die Unternehmensserver in einem abgeschlossenen und zutrittsgesicherten Raum betrieben?',
          'partial': 'Werden die Unternehmensserver in einem abgeschlossenen und zutrittsgesicherten Raum betrieben?'
        },
        'question18': {
          'question': 'Haben nur Befugte Zutritt zum Serverraum/Rechenzentrum?',
          'yes': 'Nur Befugte haben Zutritt zum Serverraum/Rechenzentrum.',
          'no': 'Haben nur Befugte Zutritt zum Serverraum/Rechenzentrum?',
          'partial': 'Haben nur Befugte Zutritt zum Serverraum/Rechenzentrum?'
        },
        'question19': {
          'question': 'Werden Maßnahmen zur Raumüberwachung des Serverraums/Rechenzentrums getroffen (Videokameras/Bewegungsmelder)?',
          'yes': 'Es wurden Maßnahmen zur Raumüberwachung des Serverraums/Rechenzentrums getroffen.',
          'no': 'Werden Maßnahmen zur Raumüberwachung des Serverraums/Rechenzentrums getroffen (Videokameras/Bewegungsmelder)?',
          'partial': 'Werden Maßnahmen zur Raumüberwachung des Serverraums/Rechenzentrums getroffen (Videokameras/Bewegungsmelder)?'
        },
        'question21': {
          'question': 'Existiert eine Regelung bzw. ein Prozess für den Fall, dass externe Kräfte Zutritt zum Serverraum/Rechenzentrum benötigen (bspw. Wartungsdienste, Reinigungsdienst, Besucher)?',
          'yes': 'Für den Zutritt externer Kräfte zum Serverraum/Rechenzentrum existieren Regelungen/Prozesse.',
          'no': 'Existiert eine Regelung bzw. ein Prozess für den Fall, dass externe Kräfte Zutritt zum Serverraum/Rechenzentrum benötigen (bspw. Wartungsdienste, Reinigungsdienst, Besucher)?',
          'partial': 'Existiert eine Regelung bzw. ein Prozess für den Fall, dass externe Kräfte Zutritt zum Serverraum/Rechenzentrum benötigen (bspw. Wartungsdienste, Reinigungsdienst, Besucher)?'
        },
        'question20': {
          'question': 'Befinden sich die Netzwerkkomponenten in dafür vorgesehenen zutrittskontrollierten Räumen (zutrittsgesichert bspw. durch den Einsatz von Ausweislesern)?',
          'yes': 'Die Netzwerkkomponenten befinden sich in dafür vorgesehenen zutrittskontrollierten Räumen.',
          'no': 'Befinden sich die Netzwerkkomponenten in dafür vorgesehenen zutrittskontrollierten Räumen (zutrittsgesichert bspw. durch den Einsatz von Ausweislesern)?',
          'partial': 'Befinden sich die Netzwerkkomponenten in dafür vorgesehenen zutrittskontrollierten Räumen (zutrittsgesichert bspw. durch den Einsatz von Ausweislesern)?'
        },
        'question53': {
          'question': 'Werden die eingerichteten Schutzmaßnahmen der Zutrittskontrolle regelmäßig einem eingehenden Test unterzogen, um festzustellen, ob sie noch den gewünschten Schutzzweck erfüllen?',
          'yes': 'Die eingerichteten Schutzmaßnahmen der Zutrittskontrolle werden regelmäßig einem eingehenden Test unterzogen, um festzustellen, ob sie noch den gewünschten Schutzzweck erfüllen.',
          'no': 'Werden die eingerichteten Schutzmaßnahmen der Zutrittskontrolle regelmäßig einem eingehenden Test unterzogen, um festzustellen, ob sie noch den gewünschten Schutzzweck erfüllen?',
          'partial': 'Werden die eingerichteten Schutzmaßnahmen der Zutrittskontrolle regelmäßig einem eingehenden Test unterzogen, um festzustellen, ob sie noch den gewünschten Schutzzweck erfüllen?'
        },
        'question22': {
          'question': 'Gibt es für alle Informationssysteme und Dienste eine formale Benutzer-Registrierung und Deregistrierung zur Vergabe und Rück-nahme von Zugangsberechtigungen?',
          'yes': 'Für alle Informationssysteme und Dienste gibt es eine formale Benutzer-Registrierung und Deregistrierung zur Vergabe und Rücknahme von Zugangsberechtigungen.',
          'no': 'Gibt es für alle Informationssysteme und Dienste eine formale Benutzer-Registrierung und Deregistrierung zur Vergabe und Rück-nahme von Zugangsberechtigungen?',
          'partial': 'Gibt es für alle Informationssysteme und Dienste eine formale Benutzer-Registrierung und Deregistrierung zur Vergabe und Rück-nahme von Zugangsberechtigungen?'
        },
        'question23': {
          'question': 'Ist sichergestellt, dass Benutzer nur Zugang zu den Netzdiensten bekommen, zu deren Nutzung sie ausdrücklich befugt sind?',
          'yes': 'Es ist sichergestellt, dass Benutzer nur Zugang zu den Netzdiensten bekommen, zu deren Nutzung sie ausdrücklich befugt sind.',
          'no': 'Ist sichergestellt, dass Benutzer nur Zugang zu den Netzdiensten bekommen, zu deren Nutzung sie ausdrücklich befugt sind?',
          'partial': 'Ist sichergestellt, dass Benutzer nur Zugang zu den Netzdiensten bekommen, zu deren Nutzung sie ausdrücklich befugt sind?'
        },
        'question55': {
          'question': 'Ist sichergestellt, dass nur berechtigte Personen logischen Zugang zu den Netzwerkkomponenten haben?',
          'yes': 'Es ist sichergestellt, dass nur berechtigte Personen logischen Zugang zu den Netzwerkkomponenten haben.',
          'no': 'Ist sichergestellt, dass nur berechtigte Personen logischen Zugang zu den Netzwerkkomponenten haben?',
          'partial': 'Ist sichergestellt, dass nur berechtigte Personen logischen Zugang zu den Netzwerkkomponenten haben?'
        },
        'question24': {
          'question': 'Gibt es ein formales Freigabeverfahren, welche Systeme und Applikationen mit personenbezogenen Daten zu durchlaufen haben, bevor diese Netzwerkzugang bekommen dürfen?',
          'yes': 'Es gibt ein formales Freigabeverfahren, welche Systeme und Applikationen mit personenbezogenen Daten zu durchlaufen haben, bevor diese Netzwerkzugang bekommen dürfen.',
          'no': 'Gibt es ein formales Freigabeverfahren, welche Systeme und Applikationen mit personenbezogenen Daten zu durchlaufen haben, bevor diese Netzwerkzugang bekommen dürfen?',
          'partial': 'Gibt es ein formales Freigabeverfahren, welche Systeme und Applikationen mit personenbezogenen Daten zu durchlaufen haben, bevor diese Netzwerkzugang bekommen dürfen?'
        },
        'question25': {
          'question': 'Ist sichergestellt, dass nur autorisierte Geräte von privaten Personen oder Besuchern logischen Zugang zum Netzwerk der Organisation bekommen?',
          'yes': 'Es ist sichergestellt, dass nur autorisierte Geräte von privaten Personen oder Besuchern logischen Zugang zum Netzwerk der Organisation bekommen.',
          'no': 'Ist sichergestellt, dass nur autorisierte Geräte von privaten Personen oder Besuchern logischen Zugang zum Netzwerk der Organisation bekommen?',
          'partial': 'Ist sichergestellt, dass nur autorisierte Geräte von privaten Personen oder Besuchern logischen Zugang zum Netzwerk der Organisation bekommen?'
        },
        'question26': {
          'question': 'Ist sichergestellt, dass das WLAN vor unbefugtem Zugang gesichert ist?',
          'yes': 'Das WLAN ist vor unbefugtem Zugang gesichert.',
          'no': 'Ist sichergestellt, dass das WLAN vor unbefugtem Zugang gesichert ist?',
          'partial': 'Ist sichergestellt, dass das WLAN vor unbefugtem Zugang gesichert ist?'
        },
        'question27': {
          'question': 'Wird in regelmäßigen Abständen von unabhängigen Testern ein Angriff auf das Netzwerk simuliert, um Schwachstellen zu identifizieren?',
          'yes': 'In regelmäßigen Abständen wird von unabhängigen Testern ein Angriff auf das Netzwerk simuliert, um Schwachstellen zu identifizieren.',
          'no': 'Wird in regelmäßigen Abständen von unabhängigen Testern ein Angriff auf das Netzwerk simuliert, um Schwachstellen zu identifizieren?',
          'partial': 'Wird in regelmäßigen Abständen von unabhängigen Testern ein Angriff auf das Netzwerk simuliert, um Schwachstellen zu identifizieren?'
        },
        'question69': {
          'question': 'Ist durch die Organisation sichergestellt, dass Softwareänderungen bei Wartungseinsätzen kontrolliert werden?',
          'yes': 'Softwareänderungen bei Wartungseinsätzen werden kontrolliert.',
          'no': 'Ist durch die Organisation sichergestellt, dass Softwareänderungen bei Wartungseinsätzen kontrolliert werden?',
          'partial': 'Ist durch die Organisation sichergestellt, dass Softwareänderungen bei Wartungseinsätzen kontrolliert werden?'
        },
        'question28': {
          'question': 'Existieren Maßnahmen zur Identifikation und Authentisierung von externem Wartungspersonal (bspw. sicherer Passwortschutz)?',
          'yes': 'Es gibt Maßnahmen zur Identifikation und Authentisierung von externem Wartungspersonal.',
          'no': 'Existieren Maßnahmen zur Identifikation und Authentisierung von externem Wartungspersonal (bspw. sicherer Passwortschutz)?',
          'partial': 'Existieren Maßnahmen zur Identifikation und Authentisierung von externem Wartungspersonal (bspw. sicherer Passwortschutz)?'
        },
        'question66': {
          'question': 'Wird das Benutzerpasswort für das Wartungspersonal unmittelbar nach dem Abschluss von Wartungsaktivitäten geändert?',
          'yes': 'Das Benutzerpasswort für das Wartungspersonal wird unmittelbar nach dem Abschluss von Wartungsaktivitäten geändert.',
          'no': 'Wird das Benutzerpasswort für das Wartungspersonal unmittelbar nach dem Abschluss von Wartungsaktivitäten geändert?',
          'partial': 'Wird das Benutzerpasswort für das Wartungspersonal unmittelbar nach dem Abschluss von Wartungsaktivitäten geändert?'
        },
        'question64': {
          'question': 'Ist bei der lokalen Wartung durch Externe sichergestellt, dass keine Ausrüstungsgegenstände (Geräte, Datenträger) den DV-Bereich unkontrolliert verlassen können?',
          'yes': 'Bei der lokalen Wartung durch Externe ist sichergestellt, dass keine Ausrüstungsgegenstände den DV-Bereich unkontrolliert verlassen können.',
          'no': 'Ist bei der lokalen Wartung durch Externe sichergestellt, dass keine Ausrüstungsgegenstände (Geräte, Datenträger) den DV-Bereich unkontrolliert verlassen können?',
          'partial': 'Ist bei der lokalen Wartung durch Externe sichergestellt, dass keine Ausrüstungsgegenstände (Geräte, Datenträger) den DV-Bereich unkontrolliert verlassen können?'
        },
        'question67': {
          'question': 'Wird bei der Fernwartung die Verbindung von einer Person aufgebaut, welche Mitglied der eigenen Organisation ist?',
          'yes': 'Bei der Fernwartung wird die Verbindung von einer Person aufgebaut, welche Mitglied der eigenen Organisation ist.',
          'no': 'Wird bei der Fernwartung die Verbindung von einer Person aufgebaut, welche Mitglied der eigenen Organisation ist?',
          'partial': 'Wird bei der Fernwartung die Verbindung von einer Person aufgebaut, welche Mitglied der eigenen Organisation ist?'
        },
        'question68': {
          'question': 'Geschieht der Verbindungsaufbau von innerhalb des Netzwerks aus?',
          'yes': 'Der Verbindungsaufbau geschieht von innerhalb des Netzwerks aus. (VPN Verbindungen)',
          'no': 'Geschieht der Verbindungsaufbau von innerhalb des Netzwerks aus?',
          'partial': 'Geschieht der Verbindungsaufbau von innerhalb des Netzwerks aus?'
        },
        'question65': {
          'question': 'Werden die eingerichteten Schutzmaßnahmen der Zugangskontrolle regelmäßig einem eingehenden Test unterzogen, um festzustellen, ob sie noch den gewünschten Schutzzweck erfüllen?',
          'yes': 'Die eingerichteten Schutzmaßnahmen der Zugangskontrolle werden regelmäßig einem eingehenden Test unterzogen, um festzustellen, ob sie noch den gewünschten Schutzzweck erfüllen.',
          'no': 'Werden die eingerichteten Schutzmaßnahmen der Zugangskontrolle regelmäßig einem eingehenden Test unterzogen, um festzustellen, ob sie noch den gewünschten Schutzzweck erfüllen?',
          'partial': 'Werden die eingerichteten Schutzmaßnahmen der Zugangskontrolle regelmäßig einem eingehenden Test unterzogen, um festzustellen, ob sie noch den gewünschten Schutzzweck erfüllen?'
        },
        'question29': {
          'question': 'Stellen die Benutzer sicher, dass ihre DV-Ausstattung (PC, Laptop, Smartphone etc.), falls unbeaufsichtigt, ausreichend (bspw. durch Abmelden vom System usw.) geschützt ist?',
          'yes': 'Die Benutzer stellen sicher, dass ihre DV-Ausstattung, falls unbeaufsichtigt, ausreichend geschützt ist.',
          'no': 'Stellen die Benutzer sicher, dass ihre DV-Ausstattung (PC, Laptop, Smartphone etc.), falls unbeaufsichtigt, ausreichend (bspw. durch Abmelden vom System usw.) geschützt ist?',
          'partial': 'Stellen die Benutzer sicher, dass ihre DV-Ausstattung (PC, Laptop, Smartphone etc.), falls unbeaufsichtigt, ausreichend (bspw. durch Abmelden vom System usw.) geschützt ist?'
        },
        'question30': {
          'question': 'Wird der Grundsatz des aufgeräumten Schreibtischs und des leeren Bildschirms gelebt (Clean Desk)?',
          'yes': 'Es wird der Grundsatz des aufgeräumten Schreibtischs und des leeren Bildschirms gelebt (Clean Desk Policy).',
          'no': 'Wird der Grundsatz des aufgeräumten Schreibtischs und des leeren Bildschirms gelebt (Clean Desk)?',
          'partial': 'Wird der Grundsatz des aufgeräumten Schreibtischs und des leeren Bildschirms gelebt (Clean Desk)?'
        },
        'question31': {
          'question': 'Wird dem Benutzer der Zeitpunkt der letztmaligen Verfahrensnutzung angezeigt?',
          'yes': 'Den Benutzern wird der Zeitpunkt der letztmaligen Verfahrensnutzung angezeigt.',
          'no': 'Wird dem Benutzer der Zeitpunkt der letztmaligen Verfahrensnutzung angezeigt?',
          'partial': 'Wird dem Benutzer der Zeitpunkt der letztmaligen Verfahrensnutzung angezeigt?'
        },
        'question32': {
          'question': 'Wird für die Gewährleistung der Datensicherheit und der Zugriffssicherung eine spezielle Sicherheitssoftware (bspw. Intrusion Detection) eines Fremdherstellers eingesetzt?',
          'yes': 'Für die Gewährleistung der Datensicherheit und der Zugriffssicherung wird eine spezielle Sicherheitssoftware eingesetzt.',
          'no': 'Wird für die Gewährleistung der Datensicherheit und der Zugriffssicherung eine spezielle Sicherheitssoftware (bspw. Intrusion Detection) eines Fremdherstellers eingesetzt?',
          'partial': 'Wird für die Gewährleistung der Datensicherheit und der Zugriffssicherung eine spezielle Sicherheitssoftware (bspw. Intrusion Detection) eines Fremdherstellers eingesetzt?'
        },
        'question70': {
          'question': 'Wird von der Verschlüsselung der Daten auf Dateiebene/Verzeichnisebene Gebrauch gemacht?',
          'yes': 'Es wird von der Verschlüsselung der Daten auf Dateiebene/Verzeichnisebene Gebrauch gemacht.',
          'no': 'Wird von der Verschlüsselung der Daten auf Dateiebene/Verzeichnisebene Gebrauch gemacht?',
          'partial': 'Wird von der Verschlüsselung der Daten auf Dateiebene/Verzeichnisebene Gebrauch gemacht?'
        },
        'question71': {
          'question': 'Werden die Informationen auf mobilen Datenträgern davor geschützt, im Verlustfall ausgelesen werden zu können?',
          'yes': 'Die Informationen auf mobilen Datenträgern davor geschützt, im Verlustfall ausgelesen werden zu können.',
          'no': 'Werden die Informationen auf mobilen Datenträgern davor geschützt, im Verlustfall ausgelesen werden zu können?',
          'partial': 'Werden die Informationen auf mobilen Datenträgern davor geschützt, im Verlustfall ausgelesen werden zu können?'
        },
        'question72': {
          'question': 'Wird die Software eines anerkannten Herstellers eingesetzt, so dass von hinreichend sicheren Verschlüsselungsalgorithmen und Schlüssellängen ausgegangen werden kann?',
          'yes': 'Es wird Software eines anerkannten Herstellers eingesetzt, so dass von hinreichend sicheren Verschlüsselungsalgorithmen und Schlüssellängen ausgegangen werden kann.',
          'no': 'Wird die Software eines anerkannten Herstellers eingesetzt, so dass von hinreichend sicheren Verschlüsselungsalgorithmen und Schlüssellängen ausgegangen werden kann?',
          'partial': 'Wird die Software eines anerkannten Herstellers eingesetzt, so dass von hinreichend sicheren Verschlüsselungsalgorithmen und Schlüssellängen ausgegangen werden kann?'
        },
        'question73': {
          'question': 'Gibt es eine Anweisung darüber, wie mit nicht mehr benötigten Datenträgern umzugehen ist (dazu gehört auch ein beschriebenes oder bedrucktes Papier)?',
          'yes': 'Es gibt Anweisungen, wie mit nicht mehr benötigten Datenträgern (einschließlich beschriebenem oder bedrucktem Papier) umzugehen ist.',
          'no': 'Gibt es eine Anweisung darüber, wie mit nicht mehr benötigten Datenträgern umzugehen ist (dazu gehört auch ein beschriebenes oder bedrucktes Papier)?',
          'partial': 'Gibt es eine Anweisung darüber, wie mit nicht mehr benötigten Datenträgern umzugehen ist (dazu gehört auch ein beschriebenes oder bedrucktes Papier)?'
        },
        'question74': {
          'question': 'Gibt es eine Anweisung darüber, wie bei der Entsorgung oder Weiterverwendung von Geräten vorzugehen ist, die mit Speichermedien ausgerüstet sind?',
          'yes': 'Die Entsorgung oder Weiterverwendung von Geräten, die mit Speichermedien ausgerüstet sind, ist geregelt.',
          'no': 'Gibt es eine Anweisung darüber, wie bei der Entsorgung oder Weiterverwendung von Geräten vorzugehen ist, die mit Speichermedien ausgerüstet sind?',
          'partial': 'Gibt es eine Anweisung darüber, wie bei der Entsorgung oder Weiterverwendung von Geräten vorzugehen ist, die mit Speichermedien ausgerüstet sind?'
        },
        'question75': {
          'question': 'Ist sichergestellt, dass Dokumente und Datenträger, deren Aufbewahrungsfrist abläuft, nachhaltig vernichtet bzw. gelöscht werden?',
          'yes': 'Es ist sichergestellt, dass Dokumente und Datenträger, deren Aufbewahrungsfrist abläuft, nachhaltig vernichtet bzw. gelöscht werden.',
          'no': 'Ist sichergestellt, dass Dokumente und Datenträger, deren Aufbewahrungsfrist abläuft, nachhaltig vernichtet bzw. gelöscht werden?',
          'partial': 'Ist sichergestellt, dass Dokumente und Datenträger, deren Aufbewahrungsfrist abläuft, nachhaltig vernichtet bzw. gelöscht werden?'
        },
        'question33': {
          'question': 'Wurden alle Personen, die mit der Verarbeitung/Nutzung personenbezogener Daten beschäftigt sind, zur Einhaltung der Vertraulichkeit verpflichtet?',
          'yes': 'Alle Personen, die mit der Verarbeitung/Nutzung personenbezogener Daten beschäftigt sind, sind zur Einhaltung der Vertraulichkeit verpflichtet.',
          'no': 'Wurden alle Personen, die mit der Verarbeitung/Nutzung personenbezogener Daten beschäftigt sind, zur Einhaltung der Vertraulichkeit verpflichtet?',
          'partial': 'Wurden alle Personen, die mit der Verarbeitung/Nutzung personenbezogener Daten beschäftigt sind, zur Einhaltung der Vertraulichkeit verpflichtet?'
        },
        'question76': {
          'question': 'Werden allen neuen Mitarbeitern bei der Verpflichtung zur Vertraulichkeit Informationen zum Datenschutz ausgehändigt?',
          'yes': 'Allen neuen Mitarbeitern werden bei der Verpflichtung zur Vertraulichkeit Informationen zum Datenschutz ausgehändigt.',
          'no': 'Werden allen neuen Mitarbeitern bei der Verpflichtung zur Vertraulichkeit Informationen zum Datenschutz ausgehändigt?',
          'partial': 'Werden allen neuen Mitarbeitern bei der Verpflichtung zur Vertraulichkeit Informationen zum Datenschutz ausgehändigt?'
        },
        'question77': {
          'question': 'Sind die Mitarbeiter, die personenbezogene Daten verarbeiten/nutzen, durch Datenschutzschulungen auf datenschutzgerechtes Verhalten am Arbeitsplatz geschult worden?',
          'yes': 'Die Mitarbeiter, die personenbezogene Daten verarbeiten/nutzen, werden durch Datenschutzschulungen auf datenschutzgerechtes Verhalten am Arbeitsplatz geschult worden.',
          'no': 'Sind die Mitarbeiter, die personenbezogene Daten verarbeiten/nutzen, durch Datenschutzschulungen auf datenschutzgerechtes Verhalten am Arbeitsplatz geschult worden?',
          'partial': 'Sind die Mitarbeiter, die personenbezogene Daten verarbeiten/nutzen, durch Datenschutzschulungen auf datenschutzgerechtes Verhalten am Arbeitsplatz geschult worden?'
        },
        'question78': {
          'question': 'Gibt es Regelungen für die Behandlung ausscheidender, insbesondere gekündigter Mitarbeiter?',
          'yes': 'Es gibt einen Prozess für ausscheidende, insbesondere gekündigte Mitarbeiter.',
          'no': 'Gibt es Regelungen für die Behandlung ausscheidender, insbesondere gekündigter Mitarbeiter?',
          'partial': 'Gibt es Regelungen für die Behandlung ausscheidender, insbesondere gekündigter Mitarbeiter?'
        },
        'question79': {
          'question': 'Gibt es ein unternehmensweit gültiges Schema für die Klassifizierung von Daten?',
          'yes': 'Es gibt ein unternehmensweit gültiges Schema für die Klassifizierung von Daten.',
          'no': 'Gibt es ein unternehmensweit gültiges Schema für die Klassifizierung von Daten?',
          'partial': 'Gibt es ein unternehmensweit gültiges Schema für die Klassifizierung von Daten?'
        },
        'question36': {
          'question': 'Sind angemessene Sicherheitsmaßnahmen für den physischen Transport von Datenträgern (inkl. Papier) umgesetzt?',
          'yes': 'Angemessene Sicherheitsmaßnahmen für den physischen Transport von Datenträgern (inkl. Papier) sind umgesetzt.',
          'no': 'Sind angemessene Sicherheitsmaßnahmen für den physischen Transport von Datenträgern (inkl. Papier) umgesetzt?',
          'partial': 'Sind angemessene Sicherheitsmaßnahmen für den physischen Transport von Datenträgern (inkl. Papier) umgesetzt?'
        },
        'question81': {
          'question': 'Sind angemessene Sicherheitsmaßnahmen für die Weitergabe von Datenträgern zu Wartungszwecken oder zur Fehleranalyse umgesetzt?',
          'yes': 'Angemessene Sicherheitsmaßnahmen für die Weitergabe von Datenträgern zu Wartungszwecken oder zur Fehleranalyse sind umgesetzt.',
          'no': 'Sind angemessene Sicherheitsmaßnahmen für die Weitergabe von Datenträgern zu Wartungszwecken oder zur Fehleranalyse umgesetzt?',
          'partial': 'Sind angemessene Sicherheitsmaßnahmen für die Weitergabe von Datenträgern zu Wartungszwecken oder zur Fehleranalyse umgesetzt?'
        },
        'question82': {
          'question': 'Erfolgt die Datenübergabe gegen Nachweis (Quittung)?',
          'yes': 'Datenübergaben erfolgen gegen Nachweis (Quittung).',
          'no': 'Erfolgt die Datenübergabe gegen Nachweis (Quittung)?',
          'partial': 'Erfolgt die Datenübergabe gegen Nachweis (Quittung)?'
        },
        'question34': {
          'question': 'Ist sichergestellt, dass Daten nur an die vom Auftraggeber festgelegten oder der Zweckbestimmung nach richtigen Adressaten übermittelt werden?',
          'yes': 'Es ist sichergestellt, dass Daten nur an die vom Auftraggeber festgelegten oder der Zweckbestimmung nach richtigen Adressaten übermittelt werden.',
          'no': 'Ist sichergestellt, dass Daten nur an die vom Auftraggeber festgelegten oder der Zweckbestimmung nach richtigen Adressaten übermittelt werden?',
          'partial': 'Ist sichergestellt, dass Daten nur an die vom Auftraggeber festgelegten oder der Zweckbestimmung nach richtigen Adressaten übermittelt werden?'
        },
        'question80': {
          'question': 'Wird eine Übersicht/Liste über diejenigen Stellen geführt, an die Datenübermittlungen programmgesteuert stattfinden können?',
          'yes': 'Es wird eine Übersicht/Liste über diejenigen Stellen geführt, an die Datenübermittlungen programmgesteuert stattfinden können.',
          'no': 'Wird eine Übersicht/Liste über diejenigen Stellen geführt, an die Datenübermittlungen programmgesteuert stattfinden können?',
          'partial': 'Wird eine Übersicht/Liste über diejenigen Stellen geführt, an die Datenübermittlungen programmgesteuert stattfinden können?'
        },
        'question83': {
          'question': 'Erfolgt eine revisionssichere Protokollierung der programmgesteuerten Übermittlungen durch Aufzeichnung des aufrufenden Verfahrens, Empfänger, Daten, Datum, Uhrzeit?',
          'yes': 'Es erfolgt eine revisionssichere Protokollierung der programmgesteuerten Übermittlungen durch Aufzeichnung des aufrufenden Verfahrens, Empfänger, Daten, Datum, Uhrzeit.',
          'no': 'Erfolgt eine revisionssichere Protokollierung der programmgesteuerten Übermittlungen durch Aufzeichnung des aufrufenden Verfahrens, Empfänger, Daten, Datum, Uhrzeit?',
          'partial': 'Erfolgt eine revisionssichere Protokollierung der programmgesteuerten Übermittlungen durch Aufzeichnung des aufrufenden Verfahrens, Empfänger, Daten, Datum, Uhrzeit?'
        },
        'question39': {
          'question': 'Erfolgt die Übermittlung der weitergegebenen Daten verschlüsselt?',
          'yes': 'Die Übermittlung von weitergegebenen Daten erfolgt verschlüsselt.',
          'no': 'Erfolgt die Übermittlung der weitergegebenen Daten verschlüsselt?',
          'partial': 'Erfolgt die Übermittlung der weitergegebenen Daten verschlüsselt?'
        },
        'question35': {
          'question': 'Wird bei der Weitergabe von Daten von den Möglichkeiten der Anonymisierung/Pseudonymisierung Gebrauch gemacht, soweit möglich?',
          'yes': 'Bei der Weitergabe von Daten wird, soweit möglich, von den Möglichkeiten der Anonymisierung/Pseudonymisierung Gebrauch gemacht.',
          'no': 'Wird bei der Weitergabe von Daten von den Möglichkeiten der Anonymisierung/Pseudonymisierung Gebrauch gemacht, soweit möglich?',
          'partial': 'Wird bei der Weitergabe von Daten von den Möglichkeiten der Anonymisierung/Pseudonymisierung Gebrauch gemacht, soweit möglich?'
        },
        'question37': {
          'question': 'Ist durch entsprechende Maßnahmen sichergestellt, dass eine Aufdeckung des Pseudonyms nicht oder nur sehr schwer möglich ist?',
          'yes': 'Durch entsprechende Maßnahmen ist sichergestellt, dass eine Aufdeckung des Pseudonyms nicht oder nur sehr schwer möglich ist.',
          'no': 'Ist durch entsprechende Maßnahmen sichergestellt, dass eine Aufdeckung des Pseudonyms nicht oder nur sehr schwer möglich ist?',
          'partial': 'Ist durch entsprechende Maßnahmen sichergestellt, dass eine Aufdeckung des Pseudonyms nicht oder nur sehr schwer möglich ist?'
        },
        'question40': {
          'question': 'Werden im Unternehmen Pseudonymisierungsverfahren mit getrennter Aufbewahrung der Zuordnungsdatei eingesetzt?',
          'yes': 'Pseudonymisierungsverfahren im Unternehmen werden mit getrennter Aufbewahrung der Zuordnungsdatei eingesetzt.',
          'no': 'Werden im Unternehmen Pseudonymisierungsverfahren mit getrennter Aufbewahrung der Zuordnungsdatei eingesetzt?',
          'partial': 'Werden im Unternehmen Pseudonymisierungsverfahren mit getrennter Aufbewahrung der Zuordnungsdatei eingesetzt?'
        },
        'question41': {
          'question': 'Werden personenbezogene Daten auf den Systemen physisch voneinander getrennt (Verarbeitung unterschiedlicher Datensätze auf getrennten Systemen)?',
          'yes': 'Personenbezogene Daten auf den Systemen werden physisch voneinander getrennt (Verarbeitung unterschiedlicher Datensätze auf getrennten Systemen).',
          'no': 'Werden personenbezogene Daten auf den Systemen physisch voneinander getrennt (Verarbeitung unterschiedlicher Datensätze auf getrennten Systemen)?',
          'partial': 'Werden personenbezogene Daten auf den Systemen physisch voneinander getrennt (Verarbeitung unterschiedlicher Datensätze auf getrennten Systemen)?'
        },
        'question42': {
          'question': 'Werden personenbezogene Daten auf den Systemen logisch voneinander getrennt (unterschiedliche Datensätze in einer einheitlichen Datenbank werden je nach Zweck markiert (softwareseitige Unterscheidbarkeit))?',
          'yes': 'Personenbezogene Daten auf den Systemen werden logisch voneinander getrennt (unterschiedliche Datensätze in einer einheitlichen Datenbank werden je nach Zweck markiert (softwareseitige Unterscheidbarkeit)).',
          'no': 'Werden personenbezogene Daten auf den Systemen logisch voneinander getrennt (unterschiedliche Datensätze in einer einheitlichen Datenbank werden je nach Zweck markiert (softwareseitige Unterscheidbarkeit))?',
          'partial': 'Werden personenbezogene Daten auf den Systemen logisch voneinander getrennt (unterschiedliche Datensätze in einer einheitlichen Datenbank werden je nach Zweck markiert (softwareseitige Unterscheidbarkeit))?'
        },
        'question43': {
          'question': 'Sind die im Unternehmen eingesetzten Systeme mandantenfähig?',
          'yes': 'Die im Unternehmen eingesetzten Systeme sind mandantenfähig.',
          'no': 'Sind die im Unternehmen eingesetzten Systeme mandantenfähig?',
          'partial': 'Sind die im Unternehmen eingesetzten Systeme mandantenfähig?'
        },
        'question38': {
          'question': 'Ist die Mandantenfähigkeit für die davon betroffenen Verfahren durchgängig realisiert?',
          'yes': 'Die Mandantenfähigkeit für die davon betroffenen Verfahren ist durchgängig realisiert.',
          'no': 'Ist die Mandantenfähigkeit für die davon betroffenen Verfahren durchgängig realisiert?',
          'partial': 'Ist die Mandantenfähigkeit für die davon betroffenen Verfahren durchgängig realisiert?'
        },
        'question84': {
          'question': 'Ist die Mandantenfähigkeit der Verfahren in der Verfahrensdokumentation nachvollziehbar dokumentiert?',
          'yes': 'Die Mandantenfähigkeit der Verfahren ist in der Verfahrensdokumentation nachvollziehbar dokumentiert.',
          'no': 'Ist die Mandantenfähigkeit der Verfahren in der Verfahrensdokumentation nachvollziehbar dokumentiert?',
          'partial': 'Ist die Mandantenfähigkeit der Verfahren in der Verfahrensdokumentation nachvollziehbar dokumentiert?'
        },
        'question44': {
          'question': 'Befinden sich Office-, Entwicklungs-, Test- und Wirksysteme in klar voneinander getrennten Netzsegmenten, vielleicht sogar physikalisch voneinander getrennt?',
          'yes': 'Office-, Entwicklungs-, Test- und Wirksysteme befinden sich in klar voneinander getrennten Netzsegmenten, wo möglich sogar physikalisch voneinander getrennt.',
          'no': 'Befinden sich Office-, Entwicklungs-, Test- und Wirksysteme in klar voneinander getrennten Netzsegmenten, vielleicht sogar physikalisch voneinander getrennt?',
          'partial': 'Befinden sich Office-, Entwicklungs-, Test- und Wirksysteme in klar voneinander getrennten Netzsegmenten, vielleicht sogar physikalisch voneinander getrennt?'
        },
        'question85': {
          'question': 'Ist sichergestellt, dass im Entwicklungs- und Testsystem nur Testdaten verarbeitet werden?',
          'yes': 'Auf Entwicklungs- und Testsystem werden nur Testdaten verarbeitet.',
          'no': 'Ist sichergestellt, dass im Entwicklungs- und Testsystem nur Testdaten verarbeitet werden?',
          'partial': 'Ist sichergestellt, dass im Entwicklungs- und Testsystem nur Testdaten verarbeitet werden?'
        },
        'question86': {
          'question': 'Ist sichergestellt, dass Testdaten, die aus Echtdaten abgeleitet werden, anonymisiert sind?',
          'yes': 'Testdaten, die aus Echtdaten abgeleitet werden, sind anonymisiert.',
          'no': 'Ist sichergestellt, dass Testdaten, die aus Echtdaten abgeleitet werden, anonymisiert sind?',
          'partial': 'Ist sichergestellt, dass Testdaten, die aus Echtdaten abgeleitet werden, anonymisiert sind?'
        },
        'question45': {
          'question': 'Ist dokumentiert, welche benutzer- oder verfahrensbezogene Auswertemöglichkeiten im Unternehmen eingesetzt werden?',
          'yes': 'Es ist dokumentiert, welche benutzer- oder verfahrensbezogene Auswertemöglichkeiten im Unternehmen eingesetzt werden.',
          'no': 'Ist dokumentiert, welche benutzer- oder verfahrensbezogene Auswertemöglichkeiten im Unternehmen eingesetzt werden?',
          'partial': 'Ist dokumentiert, welche benutzer- oder verfahrensbezogene Auswertemöglichkeiten im Unternehmen eingesetzt werden?'
        },
        'question46': {
          'question': 'Ist bekannt (und dokumentiert), welche Hilfsmittel (Audit-Programme) zur maschinellen Auswertung von Log-Dateien eingesetzt werden und welche Filterkriterien angewandt werden?',
          'yes': 'Es ist bekannt (und dokumentiert), welche Hilfsmittel (Audit-Programme) zur maschinellen Auswertung von Log-Dateien eingesetzt werden und welche Filterkriterien angewandt werden.',
          'no': 'Ist bekannt (und dokumentiert), welche Hilfsmittel (Audit-Programme) zur maschinellen Auswertung von Log-Dateien eingesetzt werden und welche Filterkriterien angewandt werden?',
          'partial': 'Ist bekannt (und dokumentiert), welche Hilfsmittel (Audit-Programme) zur maschinellen Auswertung von Log-Dateien eingesetzt werden und welche Filterkriterien angewandt werden?'
        },
        'question47': {
          'question': 'Ist geregelt, wie lange diese protokollierten Daten aufbewahrt werden dürfen?',
          'yes': 'Es ist geregelt, wie lange die protokollierten Daten aufbewahrt werden dürfen.',
          'no': 'Ist geregelt, wie lange die protokollierten Daten aufbewahrt werden dürfen?',
          'partial': 'Ist geregelt, wie lange die protokollierten Daten aufbewahrt werden dürfen?'
        },
        'question87': {
          'question': 'Unterliegen diese Daten einer strengen Zweckbestimmung?',
          'yes': 'Diese protokollierten Daten unterliegen einer strengen Zweckbestimmung.',
          'no': 'Unterliegen diese Daten einer strengen Zweckbestimmung?',
          'partial': 'Unterliegen diese Daten einer strengen Zweckbestimmung?'
        },
        'question88': {
          'question': 'Finden stichprobenartig Kontrollen durch den DSB oder durch eine andere benannte Person statt (auch hinsichtlich der Einhaltung der Löschungsfristen)?',
          'yes': 'Stichprobenartig Kontrollen durch den DSB oder durch eine andere benannte Person finden statt (auch hinsichtlich der Einhaltung der Löschungsfristen).',
          'no': 'Finden stichprobenartig Kontrollen durch den DSB oder durch eine andere benannte Person statt (auch hinsichtlich der Einhaltung der Löschungsfristen)?',
          'partial': 'Finden stichprobenartig Kontrollen durch den DSB oder durch eine andere benannte Person statt (auch hinsichtlich der Einhaltung der Löschungsfristen)?'
        },
        'question89': {
          'question': 'Sind die protokollierten Daten gegen unbefugte Einsicht oder Manipulation geschützt?',
          'yes': 'Die protokollierten Daten sind gegen unbefugte Einsicht oder Manipulation geschützt.',
          'no': 'Sind die protokollierten Daten gegen unbefugte Einsicht oder Manipulation geschützt?',
          'partial': 'Sind die protokollierten Daten gegen unbefugte Einsicht oder Manipulation geschützt?'
        },
        'question90': {
          'question': 'Werden digitale Signaturverfahren zur Manipulationserkennung eingesetzt?',
          'yes': 'Es werden digitale Signaturverfahren zur Manipulationserkennung eingesetzt.',
          'no': 'Werden digitale Signaturverfahren zur Manipulationserkennung eingesetzt?',
          'partial': 'Werden digitale Signaturverfahren zur Manipulationserkennung eingesetzt?'
        },
        'question91': {
          'question': 'Wurde ein IT-Sicherheitsbeauftragter bestellt?',
          'yes': 'Es wurde ein IT-Sicherheitsbeauftragter bestellt.',
          'no': 'Wurde ein IT-Sicherheitsbeauftragter bestellt?',
          'partial': 'Wurde ein IT-Sicherheitsbeauftragter bestellt?'
        },
        'question48': {
          'question': 'Wurde eine Risiko- und Schwachstellenanalyse durchgeführt?',
          'yes': 'Es wurde eine Risiko- und Schwachstellenanalyse durchgeführt.',
          'no': 'Wurde eine Risiko- und Schwachstellenanalyse durchgeführt?',
          'partial': 'Wurde eine Risiko- und Schwachstellenanalyse durchgeführt?'
        },
        'question92': {
          'question': 'Wurden die Risikofaktoren gegen die Aufrechterhaltung des DV-Betriebes untersucht?',
          'yes': 'Die Risikofaktoren gegen die Aufrechterhaltung des DV-Betriebes wurden untersucht.',
          'no': 'Wurden die Risikofaktoren gegen die Aufrechterhaltung des DV-Betriebes untersucht?',
          'partial': 'Wurden die Risikofaktoren gegen die Aufrechterhaltung des DV-Betriebes untersucht?'
        },
        'question93': {
          'question': 'Ist das oder sind die Gebäude vor Überschwemmungen geschützt?',
          'yes': 'Gebäude sind vor Überschwemmungen geschützt.',
          'no': 'Ist das oder sind die Gebäude vor Überschwemmungen geschützt?',
          'partial': 'Ist das oder sind die Gebäude vor Überschwemmungen geschützt?'
        },
        'question94': {
          'question': 'Sind die Systeme gegen Ausfall abgesichert?',
          'yes': 'Die Systeme sind gegen Ausfall abgesichert.',
          'no': 'Sind die Systeme gegen Ausfall abgesichert?',
          'partial': 'Sind die Systeme gegen Ausfall abgesichert?'
        },
        'question95': {
          'question': 'Wird in regelmäßigen Abständen überprüft, ob die Versorgung mit Fernmelde- und Datenleitungen, Strom, Wärme und Wasser noch ausreichend ist?',
          'yes': 'In regelmäßigen Abständen wird überprüft, ob die Versorgung mit Fernmelde- und Datenleitungen, Strom, Wärme und Wasser noch ausreichend ist.',
          'no': 'Wird in regelmäßigen Abständen überprüft, ob die Versorgung mit Fernmelde- und Datenleitungen, Strom, Wärme und Wasser noch ausreichend ist?',
          'partial': 'Wird in regelmäßigen Abständen überprüft, ob die Versorgung mit Fernmelde- und Datenleitungen, Strom, Wärme und Wasser noch ausreichend ist?'
        },
        'question96': {
          'question': 'Ist die Art der Versorgungsleitungen unterirdisch?',
          'yes': 'Die Versorgungsleitungen verlaufen unterirdisch.',
          'no': 'Ist die Art der Versorgungsleitungen unterirdisch?',
          'partial': 'Ist die Art der Versorgungsleitungen unterirdisch?'
        },
        'question97': {
          'question': 'Wurden die Netzwerk-Komponenten zum Zweck der Risikoverteilung und Ausfallminimierung auf mehrere geschützte Bereiche verteilt?',
          'yes': 'Die Netzwerk-Komponenten wurden zum Zweck der Risikoverteilung und Ausfallminimierung auf mehrere geschützte Bereiche verteilt.',
          'no': 'Wurden die Netzwerk-Komponenten zum Zweck der Risikoverteilung und Ausfallminimierung auf mehrere geschützte Bereiche verteilt?',
          'partial': 'Wurden die Netzwerk-Komponenten zum Zweck der Risikoverteilung und Ausfallminimierung auf mehrere geschützte Bereiche verteilt?'
        },
        'question98': {
          'question': 'Befinden sich keine wasserführenden Leitungen (Heizung, Frisch- und Abwasser) in den Rechnerräumen?',
          'yes': 'In den Rechnerräumen befinden sich keine wasserführenden Leitungen.',
          'no': 'Befinden sich keine wasserführenden Leitungen (Heizung, Frisch- und Abwasser) in den Rechnerräumen?',
          'partial': 'Befinden sich keine wasserführenden Leitungen (Heizung, Frisch- und Abwasser) in den Rechnerräumen?'
        },
        'question99': {
          'question': 'Ist eine vollständige Dokumentation der eingesetzten Klimatechnik vorhanden?',
          'yes': 'Eine vollständige Dokumentation der eingesetzten Klimatechnik ist vorhanden.',
          'no': 'Ist eine vollständige Dokumentation der eingesetzten Klimatechnik vorhanden?',
          'partial': 'Ist eine vollständige Dokumentation der eingesetzten Klimatechnik vorhanden?'
        },
        'question100': {
          'question': 'Werden ausreichend dimensionierte USVs eingesetzt?',
          'yes': 'Es werden ausreichend dimensionierte USVs eingesetzt.',
          'no': 'Werden ausreichend dimensionierte USVs eingesetzt?',
          'partial': 'Werden ausreichend dimensionierte USVs eingesetzt?'
        },
        'question101': {
          'question': 'Auf welche Versorgungszeit ist die USV ausgelegt?',
          'yes': 'Auf welche Versorgungszeit ist die USV ausgelegt?',
          'no': 'Auf welche Versorgungszeit ist die USV ausgelegt?',
          'partial': 'Auf welche Versorgungszeit ist die USV ausgelegt?'
        },
        'question105': {
          'question': 'Ist dokumentiert, welche Geräte bei einem Ausfall der Stromversorgung wie lange versorgt werden?',
          'yes': 'Es ist dokumentiert, welche Geräte bei einem Ausfall der Stromversorgung wie lange versorgt werden.',
          'no': 'Ist dokumentiert, welche Geräte bei einem Ausfall der Stromversorgung wie lange versorgt werden?',
          'partial': 'Ist dokumentiert, welche Geräte bei einem Ausfall der Stromversorgung wie lange versorgt werden?'
        },
        'question106': {
          'question': 'Findet eine ständige Überwachung der Ausgangsspannung(en) statt?',
          'yes': 'Es findet eine ständige Überwachung der Ausgangsspannung(en) statt.',
          'no': 'Findet eine ständige Überwachung der Ausgangsspannung(en) statt?',
          'partial': 'Findet eine ständige Überwachung der Ausgangsspannung(en) statt?'
        },
        'question107': {
          'question': 'Verfügt die USV-Anlage über Überspannungsschutzeinrichtungen?',
          'yes': 'Die USV-Anlage verfügt über Überspannungsschutzeinrichtungen.',
          'no': 'Verfügt die USV-Anlage über Überspannungsschutzeinrichtungen?',
          'partial': 'Verfügt die USV-Anlage über Überspannungsschutzeinrichtungen?'
        },
        'question102': {
          'question': 'Gibt es eine Netzersatzeinrichtung?',
          'yes': 'Es gibt Netzersatzeinrichtungen.',
          'no': 'Gibt es eine Netzersatzeinrichtung?',
          'partial': 'Gibt es eine Netzersatzeinrichtung?'
        },
        'question103': {
          'question': 'Ist die Netzersatzeinrichtung redundant ausgelegt?',
          'yes': 'Netzersatzeinrichtungen sind redundant ausgelegt.',
          'no': 'Ist die Netzersatzeinrichtung redundant ausgelegt?',
          'partial': 'Ist die Netzersatzeinrichtung redundant ausgelegt?'
        },
        'question104': {
          'question': 'Für welche Betriebsdauer ist die Netzesatzeinrichtung ausgelegt?',
          'yes': 'Für welche Betriebsdauer ist die Netzesatzeinrichtung ausgelegt?',
          'no': 'Für welche Betriebsdauer ist die Netzesatzeinrichtung ausgelegt?',
          'partial': 'Für welche Betriebsdauer ist die Netzesatzeinrichtung ausgelegt?'
        },
        'question108': {
          'question': 'Gibt es Blitzschutzeinrichtungen?',
          'yes': 'Es gibt Blitzschutzeinrichtungen.',
          'no': 'Gibt es Blitzschutzeinrichtungen?',
          'partial': 'Gibt es Blitzschutzeinrichtungen?'
        },
        'question109': {
          'question': 'Befinden sich im Serverbereich keine brennbaren Gegenstände wie Reinigungsmittel, Papiervorräte oder Papierabfälle (außer Tagesbedarf/Tagesanfall) oder Vorhänge?',
          'yes': 'Im Serverbereich befinden sichkeine brennbaren Gegenstände.',
          'no': 'Befinden sich im Serverbereich keine brennbaren Gegenstände wie Reinigungsmittel, Papiervorräte oder Papierabfälle (außer Tagesbedarf/Tagesanfall) oder Vorhänge?',
          'partial': 'Befinden sich im Serverbereich keine brennbaren Gegenstände wie Reinigungsmittel, Papiervorräte oder Papierabfälle (außer Tagesbedarf/Tagesanfall) oder Vorhänge?'
        },
        'question110': {
          'question': 'Ist ein Frühwarnsystem mit automatischen Brandmeldern (Ionisations- oder Rauchmelder) installiert?',
          'yes': 'Ein Frühwarnsystem mit automatischen Brandmeldern ist installiert.',
          'no': 'Ist ein Frühwarnsystem mit automatischen Brandmeldern (Ionisations- oder Rauchmelder) installiert?',
          'partial': 'Ist ein Frühwarnsystem mit automatischen Brandmeldern (Ionisations- oder Rauchmelder) installiert?'
        },
        'question111': {
          'question': 'Wird das Brandmeldesystem regelmäßig gewartet?',
          'yes': 'Das Brandmeldesystem wird regelmäßig gewartet.',
          'no': 'Wird das Brandmeldesystem regelmäßig gewartet?',
          'partial': 'Wird das Brandmeldesystem regelmäßig gewartet?'
        },
        'question112': {
          'question': 'Sind Druckknopfmelder zur manuellen Alarmauslösung vorhanden und deutlich gekennzeichnet?',
          'yes': 'Druckknopfmelder zur manuellen Alarmauslösung sind vorhanden und deutlich gekennzeichnet.',
          'no': 'Sind Druckknopfmelder zur manuellen Alarmauslösung vorhanden und deutlich gekennzeichnet?',
          'partial': 'Sind Druckknopfmelder zur manuellen Alarmauslösung vorhanden und deutlich gekennzeichnet?'
        },
        'question113': {
          'question': 'Werden Alarmmeldungen des Frühwarnsystems weitergegeben (Leitstelle, Werkschutz (Brandmeldestelle), Polizei, Feuerwehr, externer Wachdienst, ...)?',
          'yes': 'Alarmmeldungen des Frühwarnsystems werden weitergegeben.',
          'no': 'Werden Alarmmeldungen des Frühwarnsystems weitergegeben (Leitstelle, Werkschutz (Brandmeldestelle), Polizei, Feuerwehr, externer Wachdienst, ...)?',
          'partial': 'Werden Alarmmeldungen des Frühwarnsystems weitergegeben (Leitstelle, Werkschutz (Brandmeldestelle), Polizei, Feuerwehr, externer Wachdienst, ...)?'
        },
        'question114': {
          'question': 'Sind ausreichend geeignete Feuerlöscher/Flutungsanlagen sowie das richtige Löschmittel im Einsatz und wird dabei auf Einheitlichkeit geachtet (bspw. ausschließlich CO²-Löscher)?',
          'yes': 'Es sind ausreichend geeignete Feuerlöscher/Flutungsanlagen sowie das richtige Löschmittel im Einsatz und dabei wird auf Einheitlichkeit geachtet.',
          'no': 'Sind ausreichend geeignete Feuerlöscher/Flutungsanlagen sowie das richtige Löschmittel im Einsatz und wird dabei auf Einheitlichkeit geachtet (bspw. ausschließlich CO²-Löscher)?',
          'partial': 'Sind ausreichend geeignete Feuerlöscher/Flutungsanlagen sowie das richtige Löschmittel im Einsatz und wird dabei auf Einheitlichkeit geachtet (bspw. ausschließlich CO²-Löscher)?'
        },
        'question115': {
          'question': 'Findet eine regelmäßige Wartung und Überprüfung der Rauchmelder und Handfeuerlöscher statt?',
          'yes': 'Es findet eine regelmäßige Wartung und Überprüfung der Rauchmelder und Handfeuerlöscher statt.',
          'no': 'Findet eine regelmäßige Wartung und Überprüfung der Rauchmelder und Handfeuerlöscher statt?',
          'partial': 'Findet eine regelmäßige Wartung und Überprüfung der Rauchmelder und Handfeuerlöscher statt?'
        },
        'question116': {
          'question': 'Wurden alle in Frage kommenden Katastrophenmöglichkeiten untersucht (Streik, Personalausfall, Sachbeschädigung, Feuer, Explosion, Erdbeben, Wassereinbruch, längere Störungen oder Ausfälle der Infrastruktur)?',
          'yes': 'Alle in Frage kommenden Katastrophenmöglichkeiten wurden untersucht.',
          'no': 'Wurden alle in Frage kommenden Katastrophenmöglichkeiten untersucht (Streik, Personalausfall, Sachbeschädigung, Feuer, Explosion, Erdbeben, Wassereinbruch, längere Störungen oder Ausfälle der Infrastruktur)?',
          'partial': 'Wurden alle in Frage kommenden Katastrophenmöglichkeiten untersucht (Streik, Personalausfall, Sachbeschädigung, Feuer, Explosion, Erdbeben, Wassereinbruch, längere Störungen oder Ausfälle der Infrastruktur)?'
        },
        'question117': {
          'question': 'Gibt es ein Backup-Rechenzentrum (Ausweichrechner, Ausweichräume)?',
          'yes': 'Es gibt Backup-Rechenzentren/Ausweichrechner/Ausweichräume).',
          'no': 'Gibt es ein Backup-Rechenzentrum (Ausweichrechner, Ausweichräume)?',
          'partial': 'Gibt es ein Backup-Rechenzentrum (Ausweichrechner, Ausweichräume)?'
        },
        'question118': {
          'question': 'Existiert ein Notfallhandbuch und wird dieses laufend aktualisiert?',
          'yes': 'Es existiert ein Notfallhandbuch und dieses wird laufend aktualisiert.',
          'no': 'Existiert ein Notfallhandbuch und wird dieses laufend aktualisiert?',
          'partial': 'Existiert ein Notfallhandbuch und wird dieses laufend aktualisiert?'
        },
        'question119': {
          'question': 'Ist die Verantwortlichkeit und Weisungsbefugnis im Katastrophenfall eindeutig geregelt?',
          'yes': 'Die Verantwortlichkeit und Weisungsbefugnis im Katastrophenfall sind eindeutig geregelt.',
          'no': 'Die Verantwortlichkeit und Weisungsbefugnis im Katastrophenfall sind nicht eindeutig geregelt.',
          'partial': 'Die Verantwortlichkeit und Weisungsbefugnis im Katastrophenfall sind teilweise geregelt.'
        },
        'question120': {
          'question': 'Gibt es für den DV-Wiederanlauf eine schriftliche Unterlage (Zusammensetzung und Aufgaben des Katastrophenstabes)?',
          'yes': 'Für den DV-Wiederanlauf gibt es eine schriftliche Unterlage (Zusammensetzung und Aufgaben des Katastrophenstabes).',
          'no': 'Gibt es für den DV-Wiederanlauf eine schriftliche Unterlage (Zusammensetzung und Aufgaben des Katastrophenstabes)?',
          'partial': 'Gibt es für den DV-Wiederanlauf eine schriftliche Unterlage (Zusammensetzung und Aufgaben des Katastrophenstabes)?'
        },
        'question121': {
          'question': 'Existiert ein Notfallkonzept für das Netzwerk?',
          'yes': 'Es existiert ein Notfallkonzept für das Netzwerk.',
          'no': 'Existiert ein Notfallkonzept für das Netzwerk?',
          'partial': 'Existiert ein Notfallkonzept für das Netzwerk?'
        },
        'question122': {
          'question': 'Finden regelmäßige Notfallübungen statt?',
          'yes': 'Es finden regelmäßige Notfallübungen statt.',
          'no': 'Finden regelmäßige Notfallübungen statt?',
          'partial': 'Finden regelmäßige Notfallübungen statt?'
        },
        'question123': {
          'question': 'Werden regelmäßige Backups durchgeführt?',
          'yes': 'Es werden regelmäßige Backups durchgeführt.',
          'no': 'Werden regelmäßige Backups durchgeführt?',
          'partial': 'Werden regelmäßige Backups durchgeführt?'
        },
        'question49': {
          'question': 'Sind die Anforderungen an das Backup in einem Backup-Konzept dokumentiert?',
          'yes': 'Die Anforderungen an das Backup sind in einem Backup-Konzept dokumentiert.',
          'no': 'Sind die Anforderungen an das Backup in einem Backup-Konzept dokumentiert?',
          'partial': 'Sind die Anforderungen an das Backup in einem Backup-Konzept dokumentiert?'
        },
        'question50': {
          'question': 'Sind die Backups verschlüsselt?',
          'yes': 'Die Backups sind verschlüsselt.',
          'no': 'Sind die Backups verschlüsselt?',
          'partial': 'Sind die Backups verschlüsselt?'
        },
        'question52': {
          'question': 'Sind die Backups vor Diebstahl und Zerstörung geschützt?',
          'yes': 'Die Backups sind vor Diebstahl und Zerstörung geschützt.',
          'no': 'Sind die Backups vor Diebstahl und Zerstörung geschützt?',
          'partial': 'Sind die Backups vor Diebstahl und Zerstörung geschützt?'
        },
        'question54': {
          'question': 'Wurden Prozesse für die Sicherung erstellt und diese in Handlungsanweisungen dokumentiert?',
          'yes': 'Es wurden Prozesse für die Sicherung erstellt und diese in Handlungsanweisungen dokumentiert.',
          'no': 'Wurden Prozesse für die Sicherung erstellt und diese in Handlungsanweisungen dokumentiert?',
          'partial': 'Wurden Prozesse für die Sicherung erstellt und diese in Handlungsanweisungen dokumentiert?'
        },
        'question56': {
          'question': 'Wurden die für die Sicherung verantwortlichen Personen namentlich benannt und wurde dieses dokumentiert?',
          'yes': 'Die für die Sicherung verantwortlichen Personen wurden namentlich benannt und dies wurde dokumentiert.',
          'no': 'Wurden die für die Sicherung verantwortlichen Personen namentlich benannt und wurde dieses dokumentiert?',
          'partial': 'Wurden die für die Sicherung verantwortlichen Personen namentlich benannt und wurde dieses dokumentiert?'
        },
        'question124': {
          'question': 'Wird regelmäßig getestet, ob das Backup brauchbar ist?',
          'yes': 'Es wird regelmäßig getestet, ob das Backup brauchbar ist.',
          'no': 'Wird regelmäßig getestet, ob das Backup brauchbar ist?',
          'partial': 'Wird regelmäßig getestet, ob das Backup brauchbar ist?'
        },
        'question125': {
          'question': 'Existiert ein eigener Archivraum?',
          'yes': 'Es existiert ein eigener Archivraum.',
          'no': 'Existiert ein eigener Archivraum?',
          'partial': 'Existiert ein eigener Archivraum?'
        },
        'question126': {
          'question': 'Existiert ein Sicherheitsarchiv in einem anderen Gebäude oder Brandabschnitt?',
          'yes': 'Es existiert ein Sicherheitsarchiv in einem anderen Gebäude oder Brandabschnitt.',
          'no': 'Existiert ein Sicherheitsarchiv in einem anderen Gebäude oder Brandabschnitt?',
          'partial': 'Existiert ein Sicherheitsarchiv in einem anderen Gebäude oder Brandabschnitt?'
        },
        'question127': {
          'question': 'Ist der Zutritt zum Archiv auf einen genau festgelegten Personenkreis eingeschränkt?',
          'yes': 'Der Zutritt zum Archiv ist auf einen genau festgelegten Personenkreis eingeschränkt.',
          'no': 'Ist der Zutritt zum Archiv auf einen genau festgelegten Personenkreis eingeschränkt?',
          'partial': 'Ist der Zutritt zum Archiv auf einen genau festgelegten Personenkreis eingeschränkt?'
        },
        'question128': {
          'question': 'Befinden sich keine wasserführenden Leitungen (Heizung, Frisch- und Abwasser) in den Räumlichkeiten des Archivs bzw. in den angrenzenden Wänden?',
          'yes': 'In den Räumlichkeiten des Archivs bzw. in den angrenzenden Wänden befinden sich keine wasserführenden Leitungen.',
          'no': 'Befinden sich keine wasserführenden Leitungen (Heizung, Frisch- und Abwasser) in den Räumlichkeiten des Archivs bzw. in den angrenzenden Wänden?',
          'partial': 'Befinden sich keine wasserführenden Leitungen (Heizung, Frisch- und Abwasser) in den Räumlichkeiten des Archivs bzw. in den angrenzenden Wänden?'
        },
        'question129': {
          'question': 'Gibt es eine Notabschaltung der Stromversorgung?',
          'yes': 'Es gibt eine Notabschaltung der Stromversorgung.',
          'no': 'Gibt es eine Notabschaltung der Stromversorgung?',
          'partial': 'Gibt es eine Notabschaltung der Stromversorgung?'
        },
        'question130': {
          'question': 'Gibt es eine sinnvolle Aufteilung in Brandabschnitte?',
          'yes': 'Es gibt eine sinnvolle Aufteilung in Brandabschnitte.',
          'no': 'Gibt es eine sinnvolle Aufteilung in Brandabschnitte?',
          'partial': 'Gibt es eine sinnvolle Aufteilung in Brandabschnitte?'
        },
        'question131': {
          'question': 'Gibt es eine Überwachung der Einhaltung der Lufttemperatur und -feuchtigkeit',
          'yes': 'Die Einhaltung der Lufttemperatur und -feuchtigkeit wird überwacht.',
          'no': 'Gibt es eine Überwachung der Einhaltung der Lufttemperatur und -feuchtigkeit',
          'partial': 'Gibt es eine Überwachung der Einhaltung der Lufttemperatur und -feuchtigkeit'
        },
        'question132': {
          'question': 'Gibt es eine Löschanlage',
          'yes': 'Es gibt es eine Löschanlage.',
          'no': 'Gibt es eine Löschanlage',
          'partial': 'Gibt es eine Löschanlage'
        },
        'question133': {
          'question': 'Gibt es eine Brandvermeidungsanlage?',
          'yes': 'Es gibt eine Brandvermeidungsanlage.',
          'no': 'Gibt es eine Brandvermeidungsanlage?',
          'partial': 'Gibt es eine Brandvermeidungsanlage?'
        },
        'question134': {
          'question': 'Gibt es ein Ausweichrechenzentrum?',
          'yes': 'Es gibt ein Ausweichrechenzentrum.',
          'no': 'Gibt es ein Ausweichrechenzentrum?',
          'partial': 'Gibt es ein Ausweichrechenzentrum?'
        },
        'question135': {
          'question': 'Gibt es Staubschutzmaßnahmen?',
          'yes': 'Es gibt Staubschutzmaßnahmen.',
          'no': 'Gibt es Staubschutzmaßnahmen?',
          'partial': 'Gibt es Staubschutzmaßnahmen?'
        },
        'question136': {
          'question': 'Werden Alarmierungs- und Brandschutzübungen durchgeführt?',
          'yes': 'Es werden Alarmierungs- und Brandschutzübungen durchgeführt.',
          'no': 'Werden Alarmierungs- und Brandschutzübungen durchgeführt?',
          'partial': 'Werden Alarmierungs- und Brandschutzübungen durchgeführt?'
        },
        'question137': {
          'question': 'Werden Penetrationstests durchgeführt?',
          'yes': 'Es werden Penetrationstests durchgeführt.',
          'no': 'Werden Penetrationstests durchgeführt?',
          'partial': 'Werden Penetrationstests durchgeführt?'
        },
        'question138': {
          'question': 'Wird Antivirensoftware eingesetzt?',
          'yes': 'Es wird Antivirensoftware eingesetzt.',
          'no': 'Wird Antivirensoftware eingesetzt?',
          'partial': 'Wird Antivirensoftware eingesetzt?'
        },
        'question139': {
          'question': 'Wird ein IDS (intrusion detection system) bzw. IPS (intrusion prevention system) eingesetzt?',
          'yes': 'Es wird ein IDS (intrusion detection system) bzw. IPS (intrusion prevention system) eingesetzt.',
          'no': 'Wird ein IDS (intrusion detection system) bzw. IPS (intrusion prevention system) eingesetzt?',
          'partial': 'Wird ein IDS (intrusion detection system) bzw. IPS (intrusion prevention system) eingesetzt?'
        },
        'question57': {
          'question': 'Sind alle Auftragsverarbeiter (z. B. der Betreiber eines externen Archivs) vollständig vertraglich verpflichtet?',
          'yes': 'Alle Auftragsverarbeiter sind vollständig vertraglich verpflichtet.',
          'no': 'Sind alle Auftragsverarbeiter (z. B. der Betreiber eines externen Archivs) vollständig vertraglich verpflichtet?',
          'partial': 'Sind alle Auftragsverarbeiter (z. B. der Betreiber eines externen Archivs) vollständig vertraglich verpflichtet?'
        },
        'question58': {
          'question': 'Sind alle Auftragsverarbeitungsvertrag datenschutzrechtlich geprüft?',
          'yes': 'Alle Auftragsverarbeitungsvertrag sind datenschutzrechtlich geprüft.',
          'no': 'Sind alle Auftragsverarbeitungsvertrag datenschutzrechtlich geprüft?',
          'partial': 'Sind alle Auftragsverarbeitungsvertrag datenschutzrechtlich geprüft?'
        },
        'question60': {
          'question': 'Ist ein Datenschutz-Managementsystem (DSMS) eingeführt?',
          'yes': 'Ein Datenschutz-Managementsystem (DSMS) ist eingeführt und beinhaltet die wichtigsten datenschutzrechtlichen Vorgaben und eine umfassende Struktur zur Abbildung der Datenschutzmaßnahmen.',
          'no': 'Ist ein Datenschutz-Managementsystem (DSMS) eingeführt?',
          'partial': 'Ist ein Datenschutz-Managementsystem (DSMS) eingeführt?'
        },
        'question61': {
          'question': 'Ist ein Incident-Response-Management eingerichtet?',
          'yes': 'Ein Incident-Response-Management ist eingerichtet.',
          'no': 'Ist ein Incident-Response-Management eingerichtet?',
          'partial': 'Ist ein Incident-Response-Management eingerichtet?'
        },
        'question62': {
          'question': 'Wurden alle Systeme gemäß Art. 42 DSGVO datenschutzfreundlich eingestellt?',
          'yes': 'Alle Systeme werden gemäß Art. 42 DSGVO datenschutzfreundlich eingestellt.',
          'no': 'Wurden alle Systeme gemäß Art. 42 DSGVO datenschutzfreundlich eingestellt?',
          'partial': 'Wurden alle Systeme gemäß Art. 42 DSGVO datenschutzfreundlich eingestellt?'
        },
        'question59': {
          'question': 'Werden regelmäßige IT-Sicherheitsaudits durchgeführt?',
          'yes': 'es wird regelmäßige IT-Sicherheitsaudits durchgeführt.',
          'no': 'Werden regelmäßige IT-Sicherheitsaudits durchgeführt?',
          'partial': 'Werden regelmäßige IT-Sicherheitsaudits durchgeführt?'
        },
        'question140': {
          'question': 'In welchem Zyklus werden IT-Sicherheitsaudits durchgeführt?',
          'yes': 'In welchem Zyklus werden IT-Sicherheitsaudits durchgeführt?',
          'no': 'In welchem Zyklus werden IT-Sicherheitsaudits durchgeführt?',
          'partial': 'In welchem Zyklus werden IT-Sicherheitsaudits durchgeführt?'
        },
        'question63': {
          'question': 'Wird eine regelmäßige Aufklärung und Sensibilisierung der Mitarbeiter und Führungskräfte durchgeführt?',
          'yes': 'Eine regelmäßige Aufklärung und Sensibilisierung der Mitarbeiter und Führungskräfte werden durchgeführt.',
          'no': 'Wird eine regelmäßige Aufklärung und Sensibilisierung der Mitarbeiter und Führungskräfte durchgeführt?',
          'partial': 'Wird eine regelmäßige Aufklärung und Sensibilisierung der Mitarbeiter und Führungskräfte durchgeführt?'
        },
        'question141': {
          'question': 'Ist das Unternehmen durch ein spezielles Verfahren gemäß Art. 42 DSGVO zertifiziert, das durch die Aufsichtsbehörden anerkannt wurde?',
          'yes': 'Das Unternehmen ist durch ein spezielles Verfahren gemäß Art. 42 DSGVO zertifiziert, das durch die Aufsichtsbehörden anerkannt wurde.',
          'no': 'Ist das Unternehmen durch ein spezielles Verfahren gemäß Art. 42 DSGVO zertifiziert, das durch die Aufsichtsbehörden anerkannt wurde?',
          'partial': 'Ist das Unternehmen durch ein spezielles Verfahren gemäß Art. 42 DSGVO zertifiziert, das durch die Aufsichtsbehörden anerkannt wurde?'
        },
        'question142': {
          'question': 'Wie lautet der Name bzw. die Bezeichnung des Verfahrens?',
          'yes': 'Wie lautet der Name bzw. die Bezeichnung des Verfahrens?',
          'no': 'Wie lautet der Name bzw. die Bezeichnung des Verfahrens?',
          'partial': 'Wie lautet der Name bzw. die Bezeichnung des Verfahrens?'
        }
      },
      tomsQuestions: [],
      baseURL: baseURL
    }
  },
  created() {
    this.getSurveyBody()
  },
  computed: {
    ...mapState({user: state => state.user, account: state => state.account}),
  },
  mounted() {
  },
  methods: {
    itemClicked: async function(item) {
      const goto_page = this.survey.getPageByName(item.category)
      this.survey.currentPage = goto_page
      this.survey.getQuestionByName(item.name).focus()
      this.searchPageVisible = false
    },
    getLabel: function(item) {
      if (item) {
        return item.title
      }
      return ''
    },
    update: function(text) {
      this.items = this.tomsQuestions.filter((item) => {
        return (new RegExp(text.toLowerCase())).test(item.title.toLowerCase())
      })
    },
    gotoPage: function(command) {
      this.survey.currentPageNo = command
    },
    getSurveyBody: async function() {
      const that = this
      service.request({
        url: 'survey/v1/survey/3/',
        method: 'GET',
        responseType: 'json'
      }).then(function(response) {
        that.surveyJSON = JSON.stringify(response.data.body)
        that.survey_pages = JSON.parse(that.surveyJSON)['pages']
        that.survey_pages.forEach(page => {
          page.elements.forEach(element => {
            that.tomsQuestions.push({
              category: page.title,
              name: element.name,
              title: element.title
            })
          })
        })
        const model = new SurveyVue.Model(that.surveyJSON)
        model.data = that.surveyResult
        model.onCompleting.add(
          function(sender, options) {
            if (!that.surveyConfirmed) {
              options.allowComplete = that.completeOption
              that.resultBody = JSON.stringify(sender.data)
              that.organizeResult(JSON.stringify(sender.data))
              that.dialogVisible = true
            }
          }
        )
        model.onValueChanged.add(
          function(sender, options) {
            const survey_result = sender.data
            localStorage.setItem(`${that.saveKey}.data`, JSON.stringify(survey_result))
          }
        )
        model.completedHtml = '<p><h4>Danke für die Prüfung.</h4></p>'
        model.showPageTitles = true
        model.clearInvisibleValues = 'onHidden'
        if (localStorage.getItem(`${that.saveKey}.data`) !== null && Object.keys(that.surveyResult).length === 0) {
          that.$confirm(
            {
              message: 'Wollen Sie die Prüfung vom letzten Mal fortsetzen?',
              button: {
                no: 'Nein',
                yes: 'Ja'
              },
              callback: confirm => {
                if (confirm) {
                  model.data = JSON.parse(localStorage.getItem(`${that.saveKey}.data`))
                  that.$vToastify.success('Erfolgreich geladen')
                } else {
                  that.$vToastify.info('Neu Starten')
                }
              }
            }
          )
        }
        that.survey = model
      }).catch(function(err) {
        console.log(err)
      })
    },
    hinweiseChange: function(event) {
      if (event.target.checked === true) {
        this.organizedResult[event.target.name]['comment'] = 'Bitte auf Hinweise achten'
      } else {
        this.organizedResult[event.target.name]['comment'] = 'k.A.'
      }
    },
    closeDiaglog: function() {
      this.dialogVisible = false
    },
    confirmResult: function() {
      this.submitResult()
      this.survey.doComplete()
    },
    submitResult: function() {
      var uploadResult = {
        survey: 3,
        result_body: this.resultBody,
        customer_name: this.account.name,
        mandant: this.account.accountid,
        // sorted_result: JSON.stringify({'resultOverview':this.resultOverview, 'overviewComment': this.generalComment, 'organizedResult': this.organizedResult, 'auditResult': this.auditResult}),
        sorted_result: JSON.stringify({ 'organizedResult': this.organizedResult, 'auditResult': this.auditResult, 'auditComment': this.surveyComment }),
        createdby: this.user.id
      }
      const that = this
      service.request({
        url: '/survey/v1/tomsresult/',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: uploadResult
      }).then(function(response) {
        that.$vToastify.success({ message: 'Fertig hochgeladen', type: 'success' })
        that.surveyResponse = response.data
        that.completeOption = true
        that.dialogVisible = false
        that.surveyConfirmed = true
        // that.$router.push({ name: 'confirmtoms', params: { surveyResponse: that.surveyResponse }})
      }).catch(function(err) {
        that.dialogVisible = false
        that.$vToastify.error({ message: err.toString(), type: 'error' })
      })
    },
    answerNotify: function(title, msg) {
      const h = this.$createElement
      this.$notify({
        title: title,
        message: h('i', { style: 'color: teal' }, msg)
      })
    },
    handleClose: function(done) {
      done()
    },
    organizeResult: function(surveyResult) {
      const that = this
      Object.keys(this.organizedResult).forEach(function(key) {
        that.organizedResult[key].points = 0
        that.organizedResult[key].yes = []
        that.organizedResult[key].no = []
        that.organizedResult[key].partial = []
      })
      const resultList = JSON.parse(surveyResult)
      // console.log(resultList);
      // console.log(this.organizedResult['gegenstand'].result);
      var overviewKey = ''
      var tempObj = {}
      Object.keys(resultList).forEach(function(key) {
        // console.log(key);
        overviewKey = that.resultRelation[key]
        if (overviewKey) {
          if (key === 'question6') {
            if (resultList[key] === 'other') {
              tempObj = {
                'title': key,
                'color': failed,
                'result': 'no',
                'desc': that.resultDesc[key].other,
                'comment': resultList[key + '-Comment']
              }
            } else {
              tempObj = {
                'title': key,
                'color': failed,
                'result': 'no',
                'desc': that.resultDesc[key][resultList[key]],
                'comment': resultList[key + '-Comment']
              }
            }
            that.organizedResult[overviewKey].yes.push(tempObj)
          } else if (resultList[key] === 'item2') {
            that.organizedResult[overviewKey].color = failed
            tempObj = { 'title': key, 'color': failed, 'result': 'no', 'desc': that.resultDesc[key].no, 'comment': resultList[key + '-Comment'] }
            that.organizedResult[overviewKey].no.push(tempObj)
          } else if (resultList[key] === 'item3') {
            // overviewKey = that.resultRelation[key];
            // that.resultOverview[overviewKey] = that.resultOverview[overviewKey] + 1;
            that.organizedResult[overviewKey].points += 1
            tempObj = { 'title': key, 'color': passed, 'result': 'partial', 'desc': that.resultDesc[key].partial, 'comment': resultList[key + '-Comment'] }
            that.organizedResult[overviewKey].partial.push(tempObj)
          } else {
            that.organizedResult[overviewKey].points += 1
            tempObj = { 'title': key, 'color': passed, 'result': 'yes', 'desc': that.resultDesc[key].yes, 'comment': resultList[key + '-Comment'] }
            that.organizedResult[overviewKey].yes.push(tempObj)
          }
        }
      })
    },
    exportSurveyToExcel() {
      surveyToExcel(JSON.parse(this.surveyJSON), this.account.name, 'TOM', makeTOMCoverSheet, this.surveyResult)
    },
  }
}
</script>

<style lang="css" scoped>
.survey-menu {
  position: fixed;
  top: 180px;
  right: 20px;
}
</style>
